import React, { useState, useRef, useEffect, Dispatch, SetStateAction, SyntheticEvent, ChangeEvent, KeyboardEvent, MouseEvent, ReactNode, FC } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Avatar,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  SelectChangeEvent,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper,
  List,
  ListItem,
  ListItemText,
  FormHelperText,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Container,
  FormGroup,
  FormLabel,
  Divider,
  Alert,
  Snackbar,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  CardActions,
  ListItemIcon,
  ListItemSecondaryAction,
  Tooltip,
  Zoom,
  Fade,
  Grow,
  Slide,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tabs,
  Tab,
  Radio,
  RadioGroup,
  Switch,
  Slider,
  Rating,
  Autocomplete,
  Pagination,
  Breadcrumbs,
  Link,
  Badge,
  Drawer,
  AppBar,
  Toolbar,
  Icon,
  SvgIcon,
  DialogContentText,
} from '@mui/material';
import {
  PhotoCamera as PhotoCameraIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  ContentCopy as ContentCopyIcon,
  History as HistoryIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  CalendarToday as CalendarTodayIcon,
} from '@mui/icons-material';
import { useFormik, Formik, Form, Field, FieldProps, FieldArrayRenderProps, FormikHelpers, FieldArray } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { format, parse } from 'date-fns';
import Cropper from 'react-easy-crop';
import { FormikProps } from 'formik';
import ReactCrop, { Crop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Popover from '@mui/material/Popover';
import { useTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import esLocale from 'date-fns/locale/es';
import { API_BASE_URL, FILE_BASE_URL } from '../config';
import { getFileUrl } from '../utils/urlHelper';
import MuiAlert, { AlertColor } from '@mui/material/Alert';

const steps = [
  'Datos Personales',
  'Preferencias Alimentarias',
  'Medicamentos y Vacunas',
  'Análisis Clínicos',
  'Historial Clínico',
  'Seguimiento'
];

const PREFERENCIAS = [
  "Vegetariano", "Vegano", "Omnívoro", "Paleo", "Keto", "DASH",
  "Mediterránea", "Sin harinas refinadas", "Sin azúcar", "Raw food"
];

const INTOLERANCIAS = [
  "Gluten", "Lácteos", "Fructosa", "Histamina", "FODMAP", "Sorbitol", "Cafeína", "Aditivos"
];

const FRECUENCIAS: string[] = [
  '1 vez al día',
  '2 veces al día',
  'Cada 8 horas',
  'Cada 12 horas',
  'A demanda',
  'Otra'
];
const DURACIONES: string[] = [
  '3 días',
  '5 días',
  '7 días',
  '10 días',
  '14 días',
  '1 mes',
  'Indefinido',
  'Otra'
];

const SUGERENCIAS_FRECUENCIA: string[] = [
  '1 vez al día',
  '2 veces al día',
  'Cada 8 horas',
  'Cada 12 horas',
  'A demanda',
  'En ayunas',
  'Al despertar',
  'Antes de dormir',
  'Lunes, miércoles y viernes',
  'Cada 2 días',
  'Una vez por semana'
];

const validationSchema = Yup.object().shape({
  nombre: Yup.string().required('El nombre es requerido'),
  dni: Yup.string(),
  genero: Yup.string(),
  profesion: Yup.string(),
  obra_social: Yup.string(),
  plan: Yup.string(),
  nro_socio: Yup.string(),
  fecha_nacimiento: Yup.string().matches(
    /^\d{2}\/\d{2}\/\d{4}$/,
    'La fecha debe estar en formato DD/MM/AAAA'
  ),
  edad: Yup.number().min(0, 'La edad debe ser un número positivo'),
  altura_cm: Yup.number().min(0, 'La altura debe ser un número positivo'),
  peso_kg: Yup.number().min(0, 'El peso debe ser un número positivo'),
  religion: Yup.string(),
  familia: Yup.string(),
  email: Yup.string().email('Email inválido'),
  email2: Yup.string().email('Email inválido'),
  ruta_imagen_perfil: Yup.string(),
  preferencias: Yup.array().of(Yup.string()),
  intolerancias: Yup.array().of(Yup.string()),
  observaciones_alimentacion: Yup.string(),
  vacunas: Yup.array().of(Yup.array().of(Yup.string())),
  pesos: Yup.array().of(Yup.object().shape({
    fecha: Yup.string(),
    valor: Yup.number().min(0, 'El peso debe ser un número positivo'),
  })),
  seguimiento: Yup.array().of(Yup.object().shape({
    fecha: Yup.string(),
    texto: Yup.string(),
  })),
  analisis_resumen: Yup.string(),
  medicamentos: Yup.array().of(
    Yup.array()
      .of(Yup.mixed())
      .test('fecha-obligatoria', 'La fecha es obligatoria', arr => arr && typeof arr[0] === 'string' && arr[0].trim() !== '')
      .test('fecha-formato', 'La fecha debe tener formato DD/MM/AA', arr => {
        if (!arr || typeof arr[0] !== 'string') return false;
        return /^\d{2}\/\d{2}\/\d{2}$/.test(arr[0].trim());
      })
      .test('frecuencia-obligatoria', 'La frecuencia es obligatoria', arr => arr && typeof arr[2] === 'string' && arr[2].trim() !== '')
      .test('duracion-o-permanente', 'La duración es obligatoria si no es permanente', arr => {
        if (!arr) return false;
        const permanente = arr[4];
        const duracion = arr[3];
        if (permanente) return true;
        // Convertir duracion a string para validación segura
        const duracionStr = duracion ? String(duracion) : '';
        return duracionStr.trim() !== '' && !isNaN(Number(duracionStr)) && Number(duracionStr) > 0;
      })
  ),
});

interface DatosPersonales {
  nombre: string;
  dni?: string;
  profesion?: string;
  obra_social?: string;
  plan?: string;
  nro_socio?: string;
  fecha_nacimiento?: string;
  edad?: number;
  altura_cm?: number;
  peso_kg?: number;
  genero?: string;
  religion?: string;
  familia?: string;
  email?: string;
  email2?: string;
  ruta_imagen_perfil?: string;
  activo?: boolean;
}

interface Medicamento {
  fecha: string;
  nombre: string;
  frecuencia: string;
  duracion: string;
}

interface Vacuna {
  nombre: string;
  fecha: string;
}

interface Peso {
  fecha: string;
  valor: number;
}

interface AnalisisClinico {
  nombre: string;
  fecha: string;
  ruta_archivo: string; // El backend devuelve la ruta completa generada dinámicamente
}

interface FormValues {
  id: string;
  medico_id: string;
  nombre: string;
  dni: string;
  genero: string;
  profesion: string;
  obra_social: string;
  plan: string;
  nro_socio: string;
  fecha_nacimiento: string;
  edad: number;
  altura_cm: number;
  peso_kg: number;
  religion: string;
  familia: string;
  email: string;
  email2: string;
  ruta_imagen_perfil: string;
  foto_perfil_temp?: File;
  preferencias: string[];
  intolerancias: string[];
  observaciones_alimentacion: string;
  vacunas: string[][];
  pesos: Peso[];
  peso_fecha: string;
  peso_valor: string;
  seguimiento: Array<{fecha: string, texto: string}>;
  analisis_resumen: string;
  medicamentos: string[][];
  analisis_clinicos: Array<{nombre: string, fecha: string, ruta_archivo: string}>;
  analisis_fecha: string;
  analisis_archivo: File | null;
  analisis_nombre: string;
  obrasSociales: string[];
  
  // Aparato Circulatorio
  calambres: boolean;
  varices: boolean;
  observaciones_circulatorio: string;
  
  // Aparato Respiratorio
  alergias: boolean;
  fuma_fumo: boolean;
  observaciones_respiratorio: string;
  
  // Aparato Digestivo
  gastritis: boolean;
  frecuencia_intestino: string;
  gases_intestinales: boolean;
  dolor_abdominal: boolean;
  hepatitis: boolean;
  observaciones_digestivo: string;
  
  // Aparato Urinario
  infecciones_urinarias: boolean;
  colicos_litiasis: boolean;
  observaciones_urinario: string;
  
  // Sistema Endocrino
  enfermedad_tiroides: boolean;
  uso_corticoides: boolean;
  diabetes: boolean;
  colesterol_elevado: boolean;
  trigliceridos_elevado: boolean;
  observaciones_endocrino: string;
  
  // Sistema Dermatológico
  manchas: boolean;
  piel_seca: boolean;
  piel_grasa: boolean;
  urticaria_eczema: boolean;
  caida_cabello: boolean;
  fragilidad_unas: boolean;
  observaciones_dermatologico: string;
  
  // Sistema Locomotor
  zona_cervical: boolean;
  zona_dorsal: boolean;
  zona_lumbar: boolean;
  mmii: boolean;
  mmss: boolean;
  observaciones_locomotor: string;
  
  // Enfermedades Infecciosas
  covid: boolean;
  otras_infecciosas: string;
  
  // Sistema Ginecológico
  fum: string[];
  nueva_fum_temp: string;
  embarazos: string;
  fecha_ultimo_control: string;
  climaterio: boolean;
  observaciones_ginecologico: string;
  
  // Antecedentes Quirúrgicos
  antecedentes_quirurgicos: string;
  
  // Actividad Física y Sueño
  actividad_fisica: string;
  psicoanalisis: boolean;
  duerme_de: string;
  duerme_hasta: string;
  despertar_noche: string;
}

// Definir los valores por defecto fuera del componente
const defaultValues: FormValues = {
  id: '',
  medico_id: '',
  nombre: '',
  dni: '',
  genero: '',
  profesion: '',
  obra_social: '',
  plan: '',
  nro_socio: '',
  fecha_nacimiento: '',
  edad: 0,
  altura_cm: 0,
  peso_kg: 0,
  religion: '',
  familia: '',
  email: '',
  email2: '',
  ruta_imagen_perfil: '',
  preferencias: [],
  intolerancias: [],
  observaciones_alimentacion: '',
  vacunas: [],
  pesos: [],
  peso_fecha: '',
  peso_valor: '',
  seguimiento: [],
  analisis_resumen: '',
  medicamentos: [],
  analisis_clinicos: [],
  analisis_fecha: '',
  analisis_archivo: null,
  analisis_nombre: '',
  obrasSociales: [],
  calambres: false,
  varices: false,
  observaciones_circulatorio: '',
  alergias: false,
  fuma_fumo: false,
  observaciones_respiratorio: '',
  gastritis: false,
  frecuencia_intestino: '',
  gases_intestinales: false,
  dolor_abdominal: false,
  hepatitis: false,
  observaciones_digestivo: '',
  infecciones_urinarias: false,
  colicos_litiasis: false,
  observaciones_urinario: '',
  enfermedad_tiroides: false,
  uso_corticoides: false,
  diabetes: false,
  colesterol_elevado: false,
  trigliceridos_elevado: false,
  observaciones_endocrino: '',
  manchas: false,
  piel_seca: false,
  piel_grasa: false,
  urticaria_eczema: false,
  caida_cabello: false,
  fragilidad_unas: false,
  observaciones_dermatologico: '',
  zona_cervical: false,
  zona_dorsal: false,
  zona_lumbar: false,
  mmii: false,
  mmss: false,
  observaciones_locomotor: '',
  covid: false,
  otras_infecciosas: '',
  fum: [],
  nueva_fum_temp: '',
  embarazos: '',
  fecha_ultimo_control: '',
  climaterio: false,
  observaciones_ginecologico: '',
  antecedentes_quirurgicos: '',
  actividad_fisica: '',
  psicoanalisis: false,
  duerme_de: '',
  duerme_hasta: '',
  despertar_noche: ''
};

const convertToBackendDate = (dateStr: string): string => {
  if (!dateStr) return '';
  const [day, month, year] = dateStr.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

const uploadFile = async (file: File, pacienteId: string, tipo: string, nombre?: string, fecha?: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('paciente_id', pacienteId);
  formData.append('tipo', tipo);
  
  if (tipo === 'analisis') {
    // Para análisis, usamos el endpoint específico
    formData.append('nombre', nombre || file.name);
    formData.append('fecha', fecha || '');
    try {
      const response = await axios.post(`${API_BASE_URL}/upload-analisis`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al subir análisis:', error);
      throw error;
    }
  } else {
    // Para otros tipos de archivos (como foto de perfil) usamos el endpoint general
  if (nombre) {
    formData.append('nombre', nombre);
  }
  try {
    const response = await axios.post(`${API_BASE_URL}/upload-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error al subir archivo:', error);
    throw error;
    }
  }
};

// Función auxiliar para validar valores no válidos en el formulario
function getInvalidReactValueAlert(values: any) {
  for (const key in values) {
    const v = values[key];
    if (typeof v === 'object' && v !== null && !Array.isArray(v) && v.$$typeof) {
      return <Alert severity="error">Error: El campo "{key}" contiene un objeto React no válido.</Alert>;
    }
    if (Array.isArray(v) && v.some((item) => typeof item === 'object' && item !== null && item.$$typeof)) {
      return <Alert severity="error">Error: El campo "{key}" contiene un array con objetos React no válidos.</Alert>;
    }
  }
  return null;
}

const StepContent = ({ 
  step, 
  croppedImage, 
  onSelectFile, 
  setFieldValue, 
  values,
  calcularEdad,
  hasMoreThan7Days,
  autoPopulatePeso,
  obrasSociales,
  anchorEl,
  setAnchorEl,
  calendarDate,
  setCalendarDate,
  tabValue,
  handleTabChange,
  setCroppedImage,
  id,
  fetchAnalisis,
  analisisAEliminar,
  setAnalisisAEliminar,
  handleRemoveAnalisisFile
}: { 
  step: number, 
  croppedImage: string | null, 
  onSelectFile: (e: ChangeEvent<HTMLInputElement>) => void, 
  setFieldValue: any,
  values: FormValues,
  calcularEdad: (fechaNacimiento: string) => number,
  hasMoreThan7Days: (dateStr: string) => boolean,
  autoPopulatePeso: () => void,
  obrasSociales: string[],
  anchorEl: null | HTMLElement,
  setAnchorEl: Dispatch<SetStateAction<null | HTMLElement>>,
  calendarDate: Date | null,
  setCalendarDate: Dispatch<SetStateAction<Date | null>>,
  tabValue: number,
  handleTabChange: (event: SyntheticEvent, newValue: number) => void,
  setCroppedImage: (image: string | null) => void,
  id: string | null,
  fetchAnalisis: () => Promise<void>,
  analisisAEliminar: string[],
  setAnalisisAEliminar: Dispatch<SetStateAction<string[]>>,
  handleRemoveAnalisisFile: () => void
}) => {
  const theme = useTheme();
  const [openAnalisis, setOpenAnalisis] = useState(false);
  const [analisisActual, setAnalisisActual] = useState<any>(null);

  const handleDateClick = (event: MouseEvent<HTMLElement>, fieldName: string) => {
    setAnchorEl(event.currentTarget);
    setCalendarDate(fieldName === 'fecha_ultimo_control' && values.fecha_ultimo_control ? 
      new Date(values.fecha_ultimo_control.split('/').reverse().join('-')) : 
      null
    );
  };

  const handleDateChange = (date: Date | null, fieldName: string) => {
    if (date) {
      const formattedDate = date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      });
      setFieldValue(fieldName, formattedDate);
    }
    setAnchorEl(null);
  };

  const handleAddPeso = () => {
    if (values.peso_fecha && values.peso_valor) {
      const pesoFormateado = parseFloat(values.peso_valor).toFixed(3);
      const newPeso = {
        fecha: values.peso_fecha,
        valor: parseFloat(pesoFormateado)
      };
      setFieldValue('pesos', [...values.pesos, newPeso]);
      setFieldValue('peso_kg', parseFloat(pesoFormateado)); // Actualizar el peso en datos personales
      setFieldValue('peso_fecha', '');
      setFieldValue('peso_valor', '');
      autoPopulatePeso();
    }
  };

  const handleDeletePeso = (index: number) => {
    const newPesos = [...values.pesos];
    newPesos.splice(index, 1);
    setFieldValue('pesos', newPesos);
    
    // Si eliminamos el último peso, actualizar el peso en datos personales
    if (newPesos.length > 0) {
      const ultimoPeso = newPesos[newPesos.length - 1];
      setFieldValue('peso_kg', parseFloat(ultimoPeso.valor.toFixed(3)));
    } else {
      setFieldValue('peso_kg', 0);
    }
  };

  switch (step) {
    case 0: // Datos Personales
      return (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Field name="nombre">
              {({ field, form }: FieldProps) => (
                <TextField
                  {...field}
                  label="Nombre (obligatorio)"
                  fullWidth
                  autoComplete="off"
                  error={form.touched[field.name] && Boolean(form.errors[field.name])}
                  helperText={form.touched[field.name] && form.errors[field.name] as string}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="dni">
              {({ field, form }: FieldProps) => (
                <TextField
                  {...field}
                  label="DNI"
                  fullWidth
                  autoComplete="off"
                  error={form.touched[field.name] && Boolean(form.errors[field.name])}
                  helperText={form.touched[field.name] && form.errors[field.name] as string}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="genero">
              {({ field, form }: FieldProps) => (
                <FormControl fullWidth>
                  <InputLabel>Género</InputLabel>
                  <Select
                    {...field}
                    label="Género"
                  >
                    <MenuItem value="Masculino">Masculino</MenuItem>
                    <MenuItem value="Femenino">Femenino</MenuItem>
                  </Select>
                </FormControl>
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="fecha_nacimiento">
              {({ field, form }: FieldProps) => {
                const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
                  let value = e.target.value.replace(/[^\d]/g, ''); // Solo números
                  if (value.length > 2 && value.length <= 4) {
                    value = value.slice(0,2) + '/' + value.slice(2);
                  } else if (value.length > 4) {
                    value = value.slice(0,2) + '/' + value.slice(2,4) + '/' + value.slice(4,8);
                  }
                  form.setFieldValue(field.name, value);
                };

                const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
                  if (e.key === 'Tab') {
                    const value = field.value || '';
                    const today = new Date();
                    const day = today.getDate().toString().padStart(2, '0');
                    const month = (today.getMonth() + 1).toString().padStart(2, '0');
                    const year = today.getFullYear().toString();
                    let newValue = '';
                    if (!value) {
                      newValue = `${day}/${month}/${year}`;
                    } else if (/^\d{2}$/.test(value)) {
                      newValue = `${value}/${month}/${year}`;
                    } else if (/^\d{2}\/\d{2}$/.test(value)) {
                      newValue = `${value}/${year}`;
                    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
                      return;
                    }
                    if (newValue) {
                      e.preventDefault();
                      form.setFieldValue(field.name, newValue);
                    }
                  }
                };

                const handleBlur = () => {
                  const value = field.value;
                  if (value && value.split('/')[2]?.length === 4) {
                    const edad = calcularEdad(value);
                    form.setFieldValue('edad', edad);
                  }
                };

                return (
                  <TextField
                    {...field}
                    label="Fecha de Nacimiento"
                    fullWidth
                    autoComplete="off"
                    placeholder="DD/MM/AAAA"
                    inputProps={{ maxLength: 10, pattern: '\\d{2}/\\d{2}/\\d{4}' }}
                    onChange={handleInput}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    error={form.touched[field.name] && Boolean(form.errors[field.name])}
                    helperText={form.touched[field.name] && form.errors[field.name] as string}
                  />
                );
              }}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="profesion">
              {({ field, form }: FieldProps) => (
                <TextField
                  {...field}
                  label="Profesión"
                  fullWidth
                  autoComplete="off"
                  error={form.touched[field.name] && Boolean(form.errors[field.name])}
                  helperText={form.touched[field.name] && form.errors[field.name] as string}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="obra_social">
              {({ field, form }: FieldProps) => (
                <Autocomplete
                  freeSolo
                  options={obrasSociales}
                  value={field.value || ''}
                  onChange={(_, value) => form.setFieldValue(field.name, value || '')}
                  onInputChange={(_, value) => form.setFieldValue(field.name, value || '')}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Obra Social"
                      fullWidth
                      autoComplete="off"
                      error={form.touched[field.name] && Boolean(form.errors[field.name])}
                      helperText={form.touched[field.name] && form.errors[field.name] as string}
                    />
                  )}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="plan">
              {({ field, form }: FieldProps) => (
                <TextField
                  {...field}
                  label="Plan"
                  fullWidth
                  autoComplete="off"
                  error={form.touched[field.name] && Boolean(form.errors[field.name])}
                  helperText={form.touched[field.name] && form.errors[field.name] as string}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="nro_socio">
              {({ field, form }: FieldProps) => (
                <TextField
                  {...field}
                  label="Número de Socio"
                  fullWidth
                  autoComplete="off"
                  error={form.touched[field.name] && Boolean(form.errors[field.name])}
                  helperText={form.touched[field.name] && form.errors[field.name] as string}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="edad">
              {({ field }: FieldProps) => (
                <TextField
                  {...field}
                  label="Edad"
                  fullWidth
                  type="number"
                  InputProps={{
                    readOnly: true,
                    sx: {
                      backgroundColor: 'action.disabledBackground',
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }
                  }}
                  value={field.value || ''}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="altura_cm">
              {({ field, form }: FieldProps) => (
                <TextField
                  {...field}
                  label="Altura (cm)"
                  fullWidth
                  type="number"
                  error={form.touched[field.name] && Boolean(form.errors[field.name])}
                  helperText={form.touched[field.name] && form.errors[field.name] as string}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="peso_kg">
              {({ field }: FieldProps) => (
                <TextField
                  {...field}
                  label="Peso (kg)"
                  fullWidth
                  type="number"
                  InputProps={{
                    readOnly: true,
                    sx: {
                      backgroundColor: 'action.disabledBackground',
                      '& .MuiInputBase-input': {
                        color: 'text.secondary'
                      }
                    }
                  }}
                  value={field.value ? parseFloat(field.value).toFixed(3) : ''}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="religion">
              {({ field, form }: FieldProps) => (
                <FormControl fullWidth>
                  <InputLabel>Religión</InputLabel>
                  <Select
                    {...field}
                    label="Religión"
                  >
                    <MenuItem value="-">-</MenuItem>
                    <MenuItem value="Judío">Judío</MenuItem>
                    <MenuItem value="Ortodoxo">Ortodoxo</MenuItem>
                    <MenuItem value="Católico">Católico</MenuItem>
                    <MenuItem value="Musulmán">Musulmán</MenuItem>
                  </Select>
                </FormControl>
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="email">
              {({ field, form }: FieldProps) => (
                <TextField
                  {...field}
                  label="Email"
                  fullWidth
                  type="email"
                  autoComplete="off"
                  error={form.touched[field.name] && Boolean(form.errors[field.name])}
                  helperText={form.touched[field.name] && form.errors[field.name] as string}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="email2">
              {({ field, form }: FieldProps) => (
                <TextField
                  {...field}
                  label="Email Alternativo"
                  fullWidth
                  type="email"
                  autoComplete="off"
                  error={form.touched[field.name] && Boolean(form.errors[field.name])}
                  helperText={form.touched[field.name] && form.errors[field.name] as string}
                />
              )}
            </Field>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Field name="familia">
              {({ field, form }: FieldProps) => (
                <TextField
                  {...field}
                  label="Familia"
                  fullWidth
                  multiline
                  rows={4}
                  autoComplete="off"
                  error={form.touched[field.name] && Boolean(form.errors[field.name])}
                  helperText={form.touched[field.name] && form.errors[field.name] as string}
                />
              )}
            </Field>
          </Grid>
          <FotoPerfilSection
            nombre={values.nombre}
            ruta_imagen_perfil={values.ruta_imagen_perfil}
            croppedImage={croppedImage}
            onSelectFile={onSelectFile}
            setCroppedImage={setCroppedImage}
            setFieldValue={setFieldValue}
            medico_id={values.medico_id}
            id={values.id}
          />
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Registro de Pesos
            </Typography>
            <Grid container spacing={2} sx={{ mb: 2, alignItems: 'center' }}>
              <Grid item xs={12} sm={5}>
                <Field name="peso_fecha">
                  {({ field, form }: FieldProps) => {
                    const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
                      let value = e.target.value.replace(/[^\d]/g, ''); // Solo números
                      if (value.length > 2 && value.length <= 4) {
                        value = value.slice(0,2) + '/' + value.slice(2);
                      } else if (value.length > 4) {
                        value = value.slice(0,2) + '/' + value.slice(2,4) + '/' + value.slice(4,6);
                      }
                      form.setFieldValue(field.name, value);
                    };

                    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
                      if (e.key === 'Tab') {
                        const value = field.value || '';
                        const today = new Date();
                        const day = today.getDate().toString().padStart(2, '0');
                        const month = (today.getMonth() + 1).toString().padStart(2, '0');
                        const year = today.getFullYear().toString().slice(-2);
                        let newValue = '';
                        if (!value) {
                          newValue = `${day}/${month}/${year}`;
                        } else if (/^\d{2}$/.test(value)) {
                          newValue = `${value}/${month}/${year}`;
                        } else if (/^\d{2}\/\d{2}$/.test(value)) {
                          newValue = `${value}/${year}`;
                        } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(value)) {
                          return;
                        }
                        if (newValue) {
                          e.preventDefault();
                          form.setFieldValue(field.name, newValue);
                        }
                      }
                    };

                    return (
                      <TextField
                        {...field}
                        label="Fecha"
                        placeholder="DD/MM/AA"
                        fullWidth
                        autoComplete="off"
                        inputProps={{ maxLength: 8, pattern: '\\d{2}/\\d{2}/\\d{2}' }}
                        onChange={handleInput}
                        onKeyDown={handleKeyDown}
                        error={form.touched[field.name] && Boolean(form.errors[field.name])}
                        helperText={form.touched[field.name] && form.errors[field.name] as string}
                      />
                    );
                  }}
                </Field>
              </Grid>
              <Grid item xs={12} sm={5}>
                <Field name="peso_valor">
                  {({ field }: FieldProps) => (
                    <TextField
                      {...field}
                      label="Peso (kg)"
                      type="number"
                      autoComplete="off"
                      inputProps={{
                        step: "0.001",
                        min: "0"
                      }}
                      fullWidth
                    />
                  )}
                </Field>
              </Grid>
              <Grid item xs={12} sm={2}>
                <Button
                  startIcon={<AddIcon />}
                  variant="contained"
                  onClick={handleAddPeso}
                >
                  Registrar
                </Button>
              </Grid>
            </Grid>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Fecha</TableCell>
                    <TableCell>Peso (kg)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {values.pesos.map((peso, index) => (
                    <TableRow key={index}>
                      <TableCell>{peso.fecha}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          {typeof peso.valor === 'number' ? peso.valor.toFixed(3) : peso.valor}
                          <IconButton
                            color="error"
                            onClick={() => handleDeletePeso(index)}
                            size="small"
                            sx={{
                              opacity: 0.7,
                              transition: 'all 0.2s',
                              '&:hover': {
                                opacity: 1,
                                backgroundColor: 'rgba(211, 47, 47, 0.1)',
                                transform: 'scale(1.1)'
                              }
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      );

    case 1: // Preferencias e Intolerancias
      return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Preferencias Alimentarias
            </Typography>
            <Field name="preferencias">
              {({ field }: FieldProps) => (
                <FormControl fullWidth>
                  <Select
                    {...field}
                    multiple
                    value={field.value || []}
                    onChange={(e) => setFieldValue('preferencias', e.target.value)}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {(selected as string[]).map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                  >
                    {PREFERENCIAS.map((preferencia) => (
                      <MenuItem key={preferencia} value={preferencia}>
                        {field.value.includes(preferencia) && (
                          <span style={{ color: theme.palette.primary.main, marginRight: 8 }}>✔</span>
                        )}
                        {preferencia}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Field>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              Intolerancias
            </Typography>
            <Field name="intolerancias">
              {({ field }: FieldProps) => (
                <FormControl fullWidth>
                  <Select
                    {...field}
                    multiple
                    value={field.value || []}
                    onChange={(e) => setFieldValue('intolerancias', e.target.value)}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {(selected as string[]).map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                  >
                    {INTOLERANCIAS.map((intolerancia) => (
                      <MenuItem key={intolerancia} value={intolerancia}>
                        {field.value.includes(intolerancia) && (
                          <span style={{ color: theme.palette.primary.main, marginRight: 8 }}>✔</span>
                        )}
                        {intolerancia}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Field>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              Observaciones Alimentarias
            </Typography>
            <Field name="observaciones_alimentacion">
              {({ field }: FieldProps) => (
                <TextField
                  {...field}
                  label="Observaciones"
                  fullWidth
                  multiline
                  rows={4}
                  autoComplete="off"
                />
              )}
            </Field>
          </Grid>
        </Grid>
      );

    case 2: // Medicamentos y Vacunas
      return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Medicamentos
            </Typography>
            <FieldArray name="medicamentos">
              {({ push, remove }: FieldArrayRenderProps) => (
                <div>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    {values.medicamentos.map((medicamento: string[], index: number) => (
                      <Grid item xs={12} key={index}>
                        <Paper 
                          elevation={2} 
                          sx={{ 
                            p: 2,
                            position: 'relative',
                            '&:hover': {
                              boxShadow: 3,
                              '& .delete-button': {
                                opacity: 1
                              }
                            },
                            mb: 1,
                            bgcolor: '#fafbfc',
                            border: '1px solid #e0e0e0',
                            borderRadius: 2
                          }}
                        >
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={2} sm={2} md={2} lg={2}>
                              <Field name={`medicamentos.${index}.0`}>
                                {({ field, form, meta }: FieldProps) => {
                                  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
                                    let value = e.target.value.replace(/[^\d]/g, '');
                                    if (value.length > 2 && value.length <= 4) {
                                      value = value.slice(0,2) + '/' + value.slice(2);
                                    } else if (value.length > 4) {
                                      value = value.slice(0,2) + '/' + value.slice(2,4) + '/' + value.slice(4,6);
                                    }
                                    form.setFieldValue(field.name, value);
                                  };
                                  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
                                    if (e.key === 'Tab') {
                                      const value = field.value || '';
                                      const today = new Date();
                                      const day = today.getDate().toString().padStart(2, '0');
                                      const month = (today.getMonth() + 1).toString().padStart(2, '0');
                                      const year = today.getFullYear().toString().slice(-2);
                                      let newValue = '';
                                      if (!value) {
                                        newValue = `${day}/${month}/${year}`;
                                      } else if (/^\d{2}$/.test(value)) {
                                        newValue = `${value}/${month}/${year}`;
                                      } else if (/^\d{2}\/\d{2}$/.test(value)) {
                                        newValue = `${value}/${year}`;
                                      } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(value)) {
                                        return;
                                      }
                                      if (newValue) {
                                        e.preventDefault();
                                        form.setFieldValue(field.name, newValue);
                                      }
                                    }
                                  };
                                  return (
                                    <TextField
                                      {...field}
                                      label="Fecha"
                                      fullWidth
                                      autoComplete="off"
                                      placeholder="DD/MM/AA"
                                      inputProps={{ maxLength: 8, pattern: '\\d{2}/\\d{2}/\\d{2}' }}
                                      onChange={handleInput}
                                      onKeyDown={handleKeyDown}
                                      error={Boolean(meta.touched && meta.error)}
                                    />
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} lg={3}>
                              <Field name={`medicamentos.${index}.1`}>
                                {({ field, meta }: FieldProps) => (
                                  <TextField 
                                    {...field} 
                                    label="Medicamento"
                                    fullWidth 
                                    autoComplete="off"
                                    error={Boolean(meta.touched && meta.error)}
                                  />
                                )}
                              </Field>
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} lg={3}>
                              <Field name={`medicamentos.${index}.2`}>
                                {({ field, form, meta }: FieldProps) => (
                                  <Autocomplete
                                    freeSolo
                                    options={SUGERENCIAS_FRECUENCIA}
                                    value={field.value || ''}
                                    onInputChange={(_, newValue) => form.setFieldValue(field.name, newValue)}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        {...field}
                                        label="Frecuencia"
                                        placeholder="Ej: 1 vez al día, cada 8 horas..."
                                        autoComplete="off"
                                        error={Boolean(meta.touched && meta.error)}
                                        fullWidth
                                      />
                                    )}
                                  />
                                )}
                              </Field>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} lg={2}>
                              <Field name={`medicamentos.${index}.3`}>
                                {({ field, form, meta }: FieldProps) => (
                                  <TextField
                                    {...field}
                                    label="Duración (días)"
                                    type="number"
                                    fullWidth
                                    autoComplete="off"
                                    disabled={!!form.values.medicamentos[index][4]}
                                    error={Boolean(meta.touched && meta.error)}
                                    inputProps={{ min: 1 }}
                                  />
                                )}
                              </Field>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} lg={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: '8px', ml: '10px' }}>
                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Field name={`medicamentos.${index}.4`} type="checkbox">
                                  {({ field, form }: FieldProps) => (
                                    <Checkbox
                                      {...field}
                                      checked={!!field.value}
                                      onChange={e => {
                                        form.setFieldValue(field.name, e.target.checked);
                                        // Si se marca como permanente, limpiar el campo de duración
                                        if (e.target.checked) {
                                          form.setFieldValue(`medicamentos.${index}.3`, '');
                                        }
                                      }}
                                      size="small"
                                      sx={{ ml: 1 }}
                                    />
                                  )}
                                </Field>
                                <Typography variant="body2" sx={{ ml: 1, minWidth: 80 }}>Permanente</Typography>
                              </Box>
                            </Grid>
                          </Grid>
                          <IconButton 
                            className="delete-button"
                            onClick={() => remove(index)} 
                            color="error" 
                            size="small"
                            sx={{
                              position: 'absolute',
                              bottom: 8,
                              right: 8,
                              opacity: 0.7,
                              transition: 'all 0.2s',
                              '&:hover': {
                                opacity: 1,
                                backgroundColor: 'rgba(211, 47, 47, 0.1)',
                                transform: 'scale(1.1)'
                              }
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                  <Button
                    startIcon={<AddIcon />}
                    variant="contained"
                    onClick={() => push(['', '', '', '', ''])}
                  >
                    Agregar Medicamento
                  </Button>
                </div>
              )}
            </FieldArray>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 1 }}>
              Vacunas
            </Typography>
            <FieldArray name="vacunas">
              {({ push, remove }: FieldArrayRenderProps) => (
                <div>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    {values.vacunas.map((vacuna: string[], index: number) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <Paper 
                          elevation={2} 
                          sx={{ 
                            p: 2,
                            position: 'relative',
                            '&:hover': {
                              boxShadow: 3,
                              '& .delete-button': {
                                opacity: 1
                              }
                            }
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Field name={`vacunas.${index}.0`}>
                                {({ field, form }: FieldProps) => {
                                  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
                                    let value = e.target.value.replace(/[^\d]/g, '');
                                    if (value.length > 2 && value.length <= 4) {
                                      value = value.slice(0,2) + '/' + value.slice(2);
                                    } else if (value.length > 4) {
                                      value = value.slice(0,2) + '/' + value.slice(2,4) + '/' + value.slice(4,6);
                                    }
                                    form.setFieldValue(field.name, value);
                                  };
                                  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
                                    if (e.key === 'Tab') {
                                      const value = field.value || '';
                                      const today = new Date();
                                      const day = today.getDate().toString().padStart(2, '0');
                                      const month = (today.getMonth() + 1).toString().padStart(2, '0');
                                      const year = today.getFullYear().toString().slice(-2);
                                      let newValue = '';
                                      if (!value) {
                                        newValue = `${day}/${month}/${year}`;
                                      } else if (/^\d{2}$/.test(value)) {
                                        newValue = `${value}/${month}/${year}`;
                                      } else if (/^\d{2}\/\d{2}$/.test(value)) {
                                        newValue = `${value}/${year}`;
                                      } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(value)) {
                                        return;
                                      }
                                      if (newValue) {
                                        e.preventDefault();
                                        form.setFieldValue(field.name, newValue);
                                      }
                                    }
                                  };
                                  return (
                                    <TextField
                                      {...field}
                                      label="Fecha"
                                      fullWidth
                                      autoComplete="off"
                                      placeholder="DD/MM/AA"
                                      inputProps={{ maxLength: 8, pattern: '\\d{2}/\\d{2}/\\d{2}' }}
                                      onChange={handleInput}
                                      onKeyDown={handleKeyDown}
                                    />
                                  );
                                }}
                              </Field>
                            </Grid>
                            <Grid item xs={12}>
                              <Field name={`vacunas.${index}.1`}>
                                {({ field, meta }: FieldProps) => (
                                  <TextField 
                                    {...field} 
                                    label="Nombre"
                                    fullWidth 
                                    autoComplete="off"
                                    error={Boolean(meta.touched && meta.error)}
                                  />
                                )}
                              </Field>
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                              <IconButton 
                                className="delete-button"
                                onClick={() => remove(index)} 
                                color="error" 
                                size="small"
                                sx={{
                                  opacity: 0.7,
                                  transition: 'all 0.2s',
                                  '&:hover': {
                                    opacity: 1,
                                    backgroundColor: 'rgba(211, 47, 47, 0.1)',
                                    transform: 'scale(1.1)'
                                  }
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                  <Button
                    startIcon={<AddIcon />}
                    variant="contained"
                    onClick={() => push(['', ''])}
                  >
                    Agregar Vacuna
                  </Button>
                </div>
              )}
            </FieldArray>
          </Grid>
        </Grid>
      );

    case 3: // Análisis Clínicos
      return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Subir Análisis Clínico
            </Typography>
            <Grid container spacing={2} sx={{ alignItems: 'center' }}>
              <Grid item xs={12} sm={4}>
                <Field name="analisis_fecha">
                  {({ field, form }: FieldProps) => {
                    const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
                      let value = e.target.value.replace(/[^\d]/g, '');
                      if (value.length > 2 && value.length <= 4) {
                        value = value.slice(0,2) + '/' + value.slice(2);
                      } else if (value.length > 4) {
                        value = value.slice(0,2) + '/' + value.slice(2,4) + '/' + value.slice(4,6);
                      }
                      form.setFieldValue(field.name, value);
                    };

                    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
                      if (e.key === 'Tab') {
                        const value = field.value || '';
                        const today = new Date();
                        const day = today.getDate().toString().padStart(2, '0');
                        const month = (today.getMonth() + 1).toString().padStart(2, '0');
                        const year = today.getFullYear().toString().slice(-2);
                        let newValue = '';
                        if (!value) {
                          newValue = `${day}/${month}/${year}`;
                        } else if (/^\d{2}$/.test(value)) {
                          newValue = `${value}/${month}/${year}`;
                        } else if (/^\d{2}\/\d{2}$/.test(value)) {
                          newValue = `${value}/${year}`;
                        } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(value)) {
                          return;
                        }
                        if (newValue) {
                          e.preventDefault();
                          form.setFieldValue(field.name, newValue);
                        }
                      }
                    };

                    return (
                      <TextField
                        {...field}
                        label="Fecha del Estudio"
                        fullWidth
                        placeholder="DD/MM/AA"
                        inputProps={{ maxLength: 8, pattern: '\\d{2}/\\d{2}/\\d{2}' }}
                        onChange={handleInput}
                        onKeyDown={handleKeyDown}
                      />
                    );
                  }}
                </Field>
              </Grid>
              <Grid item xs={12} sm={8} sx={{ display: 'flex', alignItems: 'center' }}>
                <input
                  accept=".pdf,.png,.jpg,.jpeg,.bmp,.tiff,.webp"
                  style={{ display: 'none' }}
                  id="analisis-file"
                  type="file"
                  onChange={(event) => {
                    const file = event.target.files?.[0];
                    if (file) {
                      setFieldValue('analisis_archivo', file);
                      setFieldValue('analisis_nombre', file.name);
                    }
                  }}
                />
                <label htmlFor="analisis-file">
                  <Button
                    variant="outlined"
                    component="span"
                    startIcon={<AddIcon />}
                    sx={{ minWidth: 180, alignSelf: 'center' }}
                  >
                    {values.analisis_archivo ? values.analisis_archivo.name : 'Seleccionar Archivo'}
                  </Button>
                </label>
                {/* Mostrar botón de eliminar si hay archivo seleccionado */}
                {values.analisis_archivo && (
                  <IconButton color="error" onClick={handleRemoveAnalisisFile} size="small" sx={{ ml: 1 }}>
                    <DeleteIcon />
                  </IconButton>
                )}
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    if (values.analisis_archivo && values.analisis_fecha) {
                      try {
                        const response = await uploadFile(
                          values.analisis_archivo,
                          values.id,
                          'analisis',
                          values.analisis_nombre,
                          values.analisis_fecha
                        );
                        
                        // Agregar el nuevo análisis a la lista
                        const nuevoAnalisis = {
                          fecha: values.analisis_fecha,
                          nombre: response.nombre,
                          ruta_archivo: response.ruta_archivo
                        };
                        
                        setFieldValue('analisis_clinicos', [...values.analisis_clinicos, nuevoAnalisis]);
                        
                        // Limpiar los campos
                        setFieldValue('analisis_archivo', null);
                        setFieldValue('analisis_nombre', '');
                        setFieldValue('analisis_fecha', '');
                        
                        // Recargar los análisis
                        if (id) {
                          await fetchAnalisis();
                        }
                      } catch (error) {
                        console.error('Error al subir análisis:', error);
                      }
                    }
                  }}
                  disabled={!values.analisis_archivo || !values.analisis_fecha}
                >
                  Agregar Análisis
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              Análisis Clínicos Guardados
            </Typography>
            <Paper sx={{ p: 2 }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Fecha</TableCell>
                      <TableCell>Nombre</TableCell>
                      <TableCell>Acción</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {values.analisis_clinicos
                      ?.filter(a => !a.nombre.startsWith('(ELIMINADO)'))
                      .map((a: any, index: number) => {
                        // Intentar extraer la fecha del nombre del archivo
                        const match = a.nombre.match(/^(\d{2}[\/-]\d{2}[\/-]\d{2,4})/);
                        let fecha = '';
                        if (match) {
                          fecha = match[1].replace(/-/g, '/');
                        }
                        // Si no hay fecha en el nombre, usar la fecha del campo
                        return { ...a, fechaExtraida: fecha || a.fecha || values.analisis_fecha || '-' };
                      })
                      .sort((a: any, b: any) => {
                        if (a.fechaExtraida && b.fechaExtraida) {
                          const fa = a.fechaExtraida.split(/[\/]/).reverse().join('-');
                          const fb = b.fechaExtraida.split(/[\/]/).reverse().join('-');
                          return fb.localeCompare(fa);
                        }
                        return 0;
                      })
                      .map((analisis: any, index: number) => {
                        // DEBUG: Verificar rutas de análisis
                        // console.log(`[DEBUG] Análisis ${index}:`, {
                        //   nombre: analisis.nombre,
                        //   fecha: analisis.fecha,
                        //   ruta: analisis.ruta_archivo
                        // });
                        
                        return (
                        <TableRow key={index}>
                          <TableCell>{analisis.fechaExtraida}</TableCell>
                          <TableCell>{analisis.nombre}</TableCell>
                          <TableCell>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() => {
                                // console.log('[DEBUG] Abriendo análisis:', analisis);
                                setAnalisisActual(analisis);
                                setOpenAnalisis(true);
                              }}
                            >
                              Ver
                            </Button>
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => {
                                setAnalisisAEliminar(prev => [...prev, analisis.ruta_archivo]);
                                setFieldValue('analisis_clinicos', values.analisis_clinicos.filter(a => a.ruta_archivo !== analisis.ruta_archivo));
                              }}
                              sx={{
                                ml: 3,
                                opacity: 0.7,
                                transition: 'all 0.2s',
                                '&:hover': {
                                  opacity: 1,
                                  backgroundColor: 'rgba(211, 47, 47, 0.1)',
                                  transform: 'scale(1.1)'
                                }
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>

          <Dialog 
            open={openAnalisis} 
            onClose={() => setOpenAnalisis(false)} 
            maxWidth="xl" 
            fullWidth
            PaperProps={{
              sx: { mt: 4, maxHeight: '90vh' }
            }}
          >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {analisisActual?.nombre}
              <Button onClick={() => setOpenAnalisis(false)} color="error" variant="outlined" size="small">
                Cerrar
              </Button>
            </DialogTitle>
            <DialogContent sx={{ minHeight: 700, p: 0 }}>
              {analisisActual && analisisActual.ruta_archivo && analisisActual.ruta_archivo.toLowerCase().match(/\.(pdf)$/) ? (
                <iframe
                  src={`${API_BASE_URL}${analisisActual.ruta_archivo}`}
                  title="Análisis PDF"
                  width="100%"
                  height="700px"
                  style={{ border: 'none' }}
                />
              ) : analisisActual && analisisActual.ruta_archivo && analisisActual.ruta_archivo.toLowerCase().match(/\.(jpg|jpeg|png|bmp|tiff|webp)$/) ? (
                <img
                  src={`${API_BASE_URL}${analisisActual.ruta_archivo}`}
                  alt={analisisActual.nombre}
                  style={{ maxWidth: '100%', maxHeight: 700, display: 'block', margin: '0 auto' }}
                />
              ) : (
                <Typography sx={{ p: 2 }}>No se puede mostrar este tipo de archivo.</Typography>
              )}
              {/* DEBUG: Mostrar información del análisis */}
              {/* {analisisActual && (
                <Box sx={{ p: 2, bgcolor: '#f5f5f5', fontSize: '12px' }}>
                  <Typography variant="caption" display="block">
                    <strong>DEBUG:</strong> Nombre: {analisisActual.nombre}
                  </Typography>
                  <Typography variant="caption" display="block">
                    <strong>DEBUG:</strong> Ruta archivo: {analisisActual.ruta_archivo}
                  </Typography>
                  <Typography variant="caption" display="block">
                    <strong>DEBUG:</strong> API_BASE_URL: {API_BASE_URL}
                  </Typography>
                  <Typography variant="caption" display="block">
                    <strong>DEBUG:</strong> URL completa: {`${API_BASE_URL}${analisisActual.ruta_archivo}`}
                  </Typography>
                </Box>
              )} */}
            </DialogContent>
          </Dialog>
        </Grid>
      );

    case 4: // Historial Clínico
      return (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper elevation={1} sx={{ p: 2, bgcolor: '#f5f5f5' }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabValue} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
                  <Tab label="Aparatos Circulatorio y Respiratorio" />
                  <Tab label="Aparatos Digestivo y Urinario" />
                  <Tab label="Sistemas Endocrino y Dermatológico" />
                  <Tab label="Sistema Locomotor y Hábitos" />
                  <Tab label="Quirúrgico, Infeccioso y Ginecológico" />
                </Tabs>
              </Box>

              <TabPanel value={tabValue} index={0}>
        <Grid container spacing={3}>
          {/* Aparato Circulatorio */}
          <Grid item xs={12} sm={6}>
                    <Paper elevation={1} sx={{ p: 2, bgcolor: 'white' }}>
              <Typography variant="h6" gutterBottom>
                Aparato Circulatorio
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="calambres">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Calambres"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="varices">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                            label="Varices"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field name="observaciones_circulatorio">
                    {({ field }: FieldProps) => (
                      <TextField
                        {...field}
                        label="Observaciones"
                        multiline
                                rows={2}
                                fullWidth
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Aparato Respiratorio */}
          <Grid item xs={12} sm={6}>
                    <Paper elevation={1} sx={{ p: 2, bgcolor: 'white' }}>
              <Typography variant="h6" gutterBottom>
                Aparato Respiratorio
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="alergias">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Alergias"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="fuma_fumo">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Fuma/Fumó"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field name="observaciones_respiratorio">
                    {({ field }: FieldProps) => (
                      <TextField
                        {...field}
                        label="Observaciones"
                        multiline
                                rows={2}
                                fullWidth
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
                </Grid>
              </TabPanel>

              <TabPanel value={tabValue} index={1}>
                <Grid container spacing={3}>
          {/* Aparato Digestivo */}
          <Grid item xs={12} sm={6}>
                    <Paper elevation={1} sx={{ p: 2, bgcolor: 'white' }}>
              <Typography variant="h6" gutterBottom>
                Aparato Digestivo
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="gastritis">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Gastritis"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="gases_intestinales">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Gases Intestinales"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="dolor_abdominal">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Dolor Abdominal"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="hepatitis">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Hepatitis"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field name="frecuencia_intestino">
                    {({ field }: FieldProps) => (
                      <TextField
                        {...field}
                        label="Frecuencia Intestinal"
                        fullWidth
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item xs={12}>
                  <Field name="observaciones_digestivo">
                    {({ field }: FieldProps) => (
                      <TextField
                        {...field}
                        label="Observaciones"
                        multiline
                        rows={2}
                        fullWidth
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Aparato Urinario */}
          <Grid item xs={12} sm={6}>
                    <Paper elevation={1} sx={{ p: 2, bgcolor: 'white' }}>
              <Typography variant="h6" gutterBottom>
                Aparato Urinario
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="infecciones_urinarias">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Infecciones Urinarias"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="colicos_litiasis">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Cólicos/Litiasis"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field name="observaciones_urinario">
                    {({ field }: FieldProps) => (
                      <TextField
                        {...field}
                        label="Observaciones"
                        multiline
                                rows={2}
                                fullWidth
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
                </Grid>
              </TabPanel>

              <TabPanel value={tabValue} index={2}>
                <Grid container spacing={3}>
          {/* Sistema Endocrino */}
          <Grid item xs={12} sm={6}>
                    <Paper elevation={1} sx={{ p: 2, bgcolor: 'white' }}>
              <Typography variant="h6" gutterBottom>
                Sistema Endocrino
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="enfermedad_tiroides">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Enfermedad Tiroides"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="uso_corticoides">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                            label="Uso de Corticoides"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="diabetes">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Diabetes"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="colesterol_elevado">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                            label="Colesterol Elevado"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="trigliceridos_elevado">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                            label="Triglicéridos Elevado"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field name="observaciones_endocrino">
                    {({ field }: FieldProps) => (
                      <TextField
                        {...field}
                        label="Observaciones"
                        multiline
                                rows={2}
                                fullWidth
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Sistema Dermatológico */}
          <Grid item xs={12} sm={6}>
                    <Paper elevation={1} sx={{ p: 2, bgcolor: 'white' }}>
              <Typography variant="h6" gutterBottom>
                Sistema Dermatológico
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="manchas">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Manchas"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="piel_seca">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                            label="Piel Seca"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="piel_grasa">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                            label="Piel Grasa"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="urticaria_eczema">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                    label="Urticaria/Eczemas"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="caida_cabello">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                            label="Caída de Cabello"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Field name="fragilidad_unas">
                        {({ field }: FieldProps) => (
                          <Checkbox {...field} checked={field.value} />
                        )}
                      </Field>
                    }
                            label="Fragilidad de Uñas"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field name="observaciones_dermatologico">
                    {({ field }: FieldProps) => (
                      <TextField
                        {...field}
                        label="Observaciones"
                        multiline
                                rows={2}
                                fullWidth
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
                </Grid>
              </TabPanel>

              <TabPanel value={tabValue} index={3}>
                <Grid container spacing={3}>
                  {/* Columna 1: Locomotor */}
                  <Grid item xs={12} sm={6}>
                    <Paper elevation={1} sx={{ p: 2, bgcolor: 'white', height: '100%' }}>
                      <Typography variant="h6" gutterBottom>Sistema Locomotor</Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12}><FormControlLabel control={<Field name="zona_cervical">{({ field }: FieldProps) => <Checkbox {...field} checked={field.value} />}</Field>} label="Zona Cervical" /></Grid>
                        <Grid item xs={12}><FormControlLabel control={<Field name="zona_dorsal">{({ field }: FieldProps) => <Checkbox {...field} checked={field.value} />}</Field>} label="Zona Dorsal" /></Grid>
                        <Grid item xs={12}><FormControlLabel control={<Field name="zona_lumbar">{({ field }: FieldProps) => <Checkbox {...field} checked={field.value} />}</Field>} label="Zona Lumbar" /></Grid>
                        <Grid item xs={12}><FormControlLabel control={<Field name="mmii">{({ field }: FieldProps) => <Checkbox {...field} checked={field.value} />}</Field>} label="MMII" /></Grid>
                        <Grid item xs={12}><FormControlLabel control={<Field name="mmss">{({ field }: FieldProps) => <Checkbox {...field} checked={field.value} />}</Field>} label="MMSS" /></Grid>
                        <Grid item xs={12}><Field name="observaciones_locomotor">{({ field }: FieldProps) => <TextField {...field} label="Observaciones" multiline rows={2} fullWidth autoComplete="off" />}</Field></Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  {/* Columna 2: Hábitos y Sueño */}
                  <Grid item xs={12} sm={6}>
                    <Paper elevation={1} sx={{ p: 2, bgcolor: 'white', height: '100%' }}>
                      <Typography variant="h6" gutterBottom>Hábitos y Sueño</Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12}><Field name="actividad_fisica">{({ field }: FieldProps) => <TextField {...field} label="Actividad Física" fullWidth multiline rows={4} autoComplete="off" />}</Field></Grid>
                        <Grid item xs={12}><FormControlLabel control={<Field name="psicoanalisis">{({ field }: FieldProps) => <Checkbox {...field} checked={field.value} />}</Field>} label="Psicoanálisis" /></Grid>
                        <Grid item xs={12}><Field name="duerme_de">{({ field }: FieldProps) => <TextField {...field} label="Duerme de" fullWidth autoComplete="off" />}</Field></Grid>
                        <Grid item xs={12}><Field name="duerme_hasta">{({ field }: FieldProps) => <TextField {...field} label="Hasta" fullWidth autoComplete="off" />}</Field></Grid>
                        <Grid item xs={12}><Field name="duerme_de">{({ field }: FieldProps) => <TextField {...field} label="Duerme de" fullWidth />}</Field></Grid>
                        <Grid item xs={12}><Field name="duerme_hasta">{({ field }: FieldProps) => <TextField {...field} label="Hasta" fullWidth />}</Field></Grid>
                        <Grid item xs={12}><Field name="despertar_noche">{({ field }: FieldProps) => <TextField {...field} label="Despertar de Noche" fullWidth />}</Field></Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>

              <TabPanel value={tabValue} index={4}>
                <Grid container spacing={3}>
                  
                  {/* Columna 2: Antecedentes */}
                  <Grid item xs={12} sm={6}>
                    <Paper elevation={1} sx={{ p: 2, bgcolor: 'white', height: '100%' }}>
                      <Typography variant="h6" gutterBottom>Antecedentes Quirúrgicos e Infecciosos</Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12}><Field name="antecedentes_quirurgicos">{({ field }: FieldProps) => <TextField {...field} label="Antecedentes Quirúrgicos" fullWidth multiline rows={4} autoComplete="off" />}</Field></Grid>
                        <Grid item xs={12}><FormControlLabel control={<Field name="covid">{({ field }: FieldProps) => <Checkbox {...field} checked={field.value} />}</Field>} label="COVID" /></Grid>
                        <Grid item xs={12}><Field name="otras_infecciosas">{({ field }: FieldProps) => <TextField {...field} label="Otras Enfermedades Infecciosas" multiline rows={2} fullWidth />}</Field></Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                  {/* Columna 1: Ginecológico */}
                  <Grid item xs={12} sm={6}>
                    <Paper elevation={1} sx={{ p: 2, bgcolor: 'white', height: '100%' }}>
                      <Typography variant="h6" gutterBottom>Antecedentes Ginecológicos</Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
                            FUM (Últimos 6 meses)
                          </Typography>
                          <FieldArray name="fum">
                            {({ push, remove, form }) => {
                              // Función para agregar fecha ordenada
                              const agregarFechaOrdenada = (nuevaFecha: string) => {
                                if (!nuevaFecha || nuevaFecha.length < 8) return;
                                
                                // Convertir fecha a timestamp para comparación
                                const parseFecha = (fechaStr: string) => {
                                  const partes = fechaStr.split('/');
                                  if (partes.length !== 3) return 0;
                                  const dia = parseInt(partes[0]);
                                  const mes = parseInt(partes[1]) - 1;
                                  const anio = parseInt(partes[2]) + 2000; // Asumir siglo 21
                                  return new Date(anio, mes, dia).getTime();
                                };
                                
                                const nuevaFechaTimestamp = parseFecha(nuevaFecha);
                                if (nuevaFechaTimestamp === 0) return;
                                
                                // Verificar si la fecha ya existe
                                const fechasExistentes = [...values.fum];
                                const fechaExiste = fechasExistentes.some(fecha => 
                                  parseFecha(fecha) === nuevaFechaTimestamp
                                );
                                
                                if (fechaExiste) {
                                  alert('Esta fecha ya está registrada');
                                  return;
                                }
                                
                                // Agregar la nueva fecha
                                fechasExistentes.push(nuevaFecha);
                                
                                // Ordenar de más reciente a más antigua
                                fechasExistentes.sort((a, b) => {
                                  const timestampA = parseFecha(a);
                                  const timestampB = parseFecha(b);
                                  return timestampB - timestampA; // Orden descendente
                                });
                                
                                // Limitar a 6 fechas
                                const fechasLimitadas = fechasExistentes.slice(0, 6);
                                
                                form.setFieldValue('fum', fechasLimitadas);
                                form.setFieldValue('nueva_fum_temp', '');
                              };
                              
                              return (
                                <Box>
                                  {/* Campo de entrada para nueva fecha */}
                                  <Box sx={{ display: 'flex', gap: 1, mb: 2, alignItems: 'center' }}>
                                    <Field name="nueva_fum_temp">
                                      {({ field }: FieldProps) => {
                                        const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
                                          let v = e.target.value.replace(/[^\d]/g, '');
                                          if (v.length > 2) v = v.slice(0, 2) + '/' + v.slice(2);
                                          if (v.length > 5) v = v.slice(0, 5) + '/' + v.slice(5, 7);
                                          form.setFieldValue('nueva_fum_temp', v);
                                        };
                                        
                                        const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
                                          if (e.key === 'Enter' && field.value) {
                                            e.preventDefault();
                                            agregarFechaOrdenada(field.value);
                                          } else if (e.key === 'Tab') {
                                            const value = field.value || '';
                                            const today = new Date();
                                            const day = today.getDate().toString().padStart(2, '0');
                                            const month = (today.getMonth() + 1).toString().padStart(2, '0');
                                            const year = today.getFullYear().toString().slice(-2);
                                            let newValue = '';
                                            if (!value) {
                                              newValue = `${day}/${month}/${year}`;
                                            } else if (/^\d{2}$/.test(value)) {
                                              newValue = `${value}/${month}/${year}`;
                                            } else if (/^\d{2}\/\d{2}$/.test(value)) {
                                              newValue = `${value}/${year}`;
                                            } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(value)) {
                                              return;
                                            }
                                            if (newValue) {
                                              e.preventDefault();
                                              form.setFieldValue('nueva_fum_temp', newValue);
                                            }
                                          }
                                        };
                                        
                                        return (
                                          <TextField
                                            {...field}
                                            size="small"
                                            placeholder="DD/MM/AA"
                                            label="Nueva fecha FUM"
                                            sx={{ flex: 1 }}
                                            inputProps={{ maxLength: 8 }}
                                            onChange={handleInput}
                                            onKeyDown={handleKeyDown}
                                          />
                                        );
                                      }}
                                    </Field>
                                    <Button
                                      size="small"
                                      onClick={() => {
                                        const tempValue = form.values.nueva_fum_temp;
                                        if (tempValue) {
                                          agregarFechaOrdenada(tempValue);
                                        }
                                      }}
                                      disabled={!form.values.nueva_fum_temp}
                                      variant="contained"
                                      sx={{ minWidth: 'auto', px: 2 }}
                                    >
                                      +
                                    </Button>
                                  </Box>

                                  {/* Chips con las fechas agregadas */}
                                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1 }}>
                                    {values.fum.map((fecha: string, index: number) => (
                                      <Chip
                                        key={index}
                                        label={`${index === 0 ? 'Actual' : `${index} mes${index > 1 ? 'es' : ''} antes`}: ${fecha}`}
                                        onDelete={() => remove(index)}
                                        color={index === 0 ? "primary" : "default"}
                                        variant={index === 0 ? "filled" : "outlined"}
                                        size="small"
                                        sx={{ 
                                          fontSize: '0.75rem',
                                          '& .MuiChip-deleteIcon': {
                                            fontSize: '1rem'
                                          }
                                        }}
                                      />
                                    ))}
                                  </Box>

                                  {/* Información adicional */}
                                  <Typography variant="caption" color="text.secondary">
                                    {values.fum.length}/6 fechas. Presiona Enter o Tab para auto-completar fecha actual.
                                  </Typography>
                                </Box>
                              );
                            }}
                          </FieldArray>
                        </Grid>
                        <Grid item xs={12}><Field name="embarazos">{({ field }: FieldProps) => <TextField {...field} label="Embarazos" fullWidth />}</Field></Grid>
                        <Grid item xs={12}><Field name="fecha_ultimo_control">{({ field, form }: FieldProps) => { const handleInput = (e: ChangeEvent<HTMLInputElement>) => { let v = e.target.value.replace(/[^\d]/g, ''); if (v.length > 2) v = v.slice(0, 2) + '/' + v.slice(2); if (v.length > 5) v = v.slice(0, 5) + '/' + v.slice(5, 7); form.setFieldValue(field.name, v); }; return (<TextField {...field} label="Fecha del Último Control" placeholder="DD/MM/AA" fullWidth autoComplete="off" onChange={handleInput} />); }}</Field></Grid>
                        <Grid item xs={12}><Field name="fecha_ultimo_control">{({ field, form }: FieldProps) => { const handleInput = (e: ChangeEvent<HTMLInputElement>) => { let v = e.target.value.replace(/[^\d]/g, ''); if (v.length > 2) v = v.slice(0, 2) + '/' + v.slice(2); if (v.length > 5) v = v.slice(0, 5) + '/' + v.slice(5, 7); form.setFieldValue(field.name, v); }; return (<TextField {...field} label="Fecha del Último Control" placeholder="DD/MM/AA" fullWidth onChange={handleInput} />); }}</Field></Grid>
                        <Grid item xs={12}><FormControlLabel control={<Field name="climaterio">{({ field }: FieldProps) => <Checkbox {...field} checked={field.value} />}</Field>} label="Climaterio" /></Grid>
                        <Grid item xs={12}><Field name="observaciones_ginecologico">{({ field }: FieldProps) => <TextField {...field} label="Observaciones" multiline rows={2} fullWidth />}</Field></Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>
            </Paper>
          </Grid>
        </Grid>
      );

    case 5: // Seguimiento
      // Función para reordenar seguimientos por fecha descendente
      const ordenarSeguimientos = (seguimientos: {fecha: string, texto: string}[]) => {
        const parseFecha = (f: string) => {
          if (!f) return 0;
          const partes = f.split('/');
          if (partes.length < 3) return 0;
          let anio = partes[2].length === 2 ? '20' + partes[2] : partes[2];
          return new Date(`${anio}-${partes[1]}-${partes[0]}`).getTime();
        };
        return [...seguimientos].sort((a, b) => parseFecha(b.fecha) - parseFecha(a.fecha));
      };

      // Handler para onBlur del campo fecha
      const handleBlurFechaSeguimiento = (index: number, form: any) => {
        const nuevos = ordenarSeguimientos(form.values.seguimiento);
        form.setFieldValue('seguimiento', nuevos);
      };

      return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Seguimiento
            </Typography>
            <FieldArray name="seguimiento">
              {({ push, remove, form }) => (
                <div>
                  {values.seguimiento.map((seguimiento: {fecha: string, texto: string}, index: number) => (
                    <Paper
                      key={index}
                      elevation={3}
                      sx={{
                        p: 2,
                        mb: 2,
                        borderRadius: 4,
                        background: 'linear-gradient(90deg, #f5f7fa 0%, #c3cfe2 100%)',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: 2,
                        position: 'relative',
                        minHeight: 80
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Field name={`seguimiento.${index}.fecha`}>
                          {({ field }: FieldProps) => {
                            // Lógica de autocompletado y formato DD/MM/AA
                            const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
                              let value = e.target.value.replace(/[^\d]/g, '');
                              if (value.length > 2 && value.length <= 4) {
                                value = value.slice(0,2) + '/' + value.slice(2);
                              } else if (value.length > 4) {
                                value = value.slice(0,2) + '/' + value.slice(2,4) + '/' + value.slice(4,6);
                              }
                              form.setFieldValue(field.name, value);
                            };
                            const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
                              if (e.key === 'Tab') {
                                const value = field.value || '';
                                const today = new Date();
                                const day = today.getDate().toString().padStart(2, '0');
                                const month = (today.getMonth() + 1).toString().padStart(2, '0');
                                const year = today.getFullYear().toString().slice(-2);
                                let newValue = '';
                                if (!value) {
                                  newValue = `${day}/${month}/${year}`;
                                } else if (/^\d{2}$/.test(value)) {
                                  newValue = `${value}/${month}/${year}`;
                                } else if (/^\d{2}\/\d{2}$/.test(value)) {
                                  newValue = `${value}/${year}`;
                                } else if (/^\d{2}\/\d{2}\/\d{2}$/.test(value)) {
                                  return;
                                }
                                if (newValue) {
                                  e.preventDefault();
                                  form.setFieldValue(field.name, newValue);
                                }
                              }
                            };
                            return (
                              <TextField
                                {...field}
                                label="Fecha"
                                size="small"
                                autoComplete="off"
                                sx={{ mb: 1, maxWidth: 140 }}
                                inputProps={{ maxLength: 8, pattern: '\\d{2}/\\d{2}/\\d{2}' }}
                                onChange={handleInput}
                                onKeyDown={handleKeyDown}
                                onBlur={() => handleBlurFechaSeguimiento(index, form)}
                              />
                            );
                          }}
                        </Field>
                        <Field name={`seguimiento.${index}.texto`}>
                          {({ field }: FieldProps) => (
                            <TextField
                              {...field}
                              label="Observación"
                              size="small"
                              multiline
                              minRows={2}
                              maxRows={6}
                              fullWidth
                              autoComplete="off"
                              sx={{ background: 'rgba(255,255,255,0.7)', borderRadius: 2, mt: 1 }}
                            />
                          )}
                        </Field>
                      </Box>
                      <IconButton
                        onClick={() => remove(index)}
                        color="error"
                        sx={{
                          alignSelf: 'flex-start',
                          opacity: 0.7,
                          transition: 'all 0.2s',
                          ml: 2,
                          '&:hover': {
                            opacity: 1,
                            backgroundColor: 'rgba(211, 47, 47, 0.1)',
                            transform: 'scale(1.1)'
                          }
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Paper>
                  ))}
                  <Button
                    startIcon={<AddIcon />}
                    onClick={() => push({ fecha: '', texto: '' })}
                    variant="outlined"
                    sx={{ mt: 2 }}
                  >
                    Agregar Seguimiento
                  </Button>
                </div>
              )}
            </FieldArray>
          </Grid>
        </Grid>
      );

    default:
      return null;
  }
};

function FotoPerfilSection({ 
  nombre, 
  ruta_imagen_perfil, 
  croppedImage, 
  onSelectFile, 
  setCroppedImage,
  setFieldValue,
  medico_id,
  id
}: { 
  nombre: string, 
  ruta_imagen_perfil?: string, 
  croppedImage: string | null, 
  onSelectFile: (e: ChangeEvent<HTMLInputElement>) => void,
  setCroppedImage: (image: string | null) => void,
  setFieldValue: (field: string, value: any) => void,
  medico_id?: string,
  id?: string
}) {
  const imgRef = useRef<HTMLImageElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [imgSrc, setImgSrc] = useState<string>('');
  const [crop, setCrop] = useState<Crop>({
    unit: 'px',
    width: 300,
    height: 300,
    x: 0,
    y: 0
  });
  const [showCropModal, setShowCropModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const getCroppedImg = (image: HTMLImageElement, crop: Crop): Promise<string> => {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    
    // Asegurar que el canvas sea cuadrado
    const size = Math.min(crop.width, crop.height);
    canvas.width = size;
    canvas.height = size;
    
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('No 2d context');
    }

    // Crear un círculo para el recorte
    ctx.beginPath();
    ctx.arc(size/2, size/2, size/2, 0, Math.PI * 2);
    ctx.closePath();
    ctx.clip();

    // Dibujar la imagen recortada
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      size,
      size
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          throw new Error('Canvas is empty');
        }
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result as string);
        };
        reader.readAsDataURL(blob);
      }, 'image/jpeg', 0.95);
    });
  };

  const handleCropComplete = async () => {
    if (imgRef.current && crop.width && crop.height) {
      try {
        const croppedImageUrl = await getCroppedImg(imgRef.current, crop);
        
        // Actualizar la vista previa inmediatamente
        setCroppedImage(croppedImageUrl);
        
        // Crear un nuevo archivo a partir de la imagen recortada
        const response = await fetch(croppedImageUrl);
        const blob = await response.blob();
        let baseName = selectedFile?.name || 'cropped-image.jpg';
        baseName = baseName.replace(/(\.jpg|\.jpeg|\.png)$/i, ''); // quita la extensión si existe
        const file = new File([blob], `${baseName}.jpg`, { type: 'image/jpeg' });
        
        // Guardar el archivo temporalmente sin subirlo
        setFieldValue('foto_perfil_temp', file);
        
        setShowCropModal(false);
        setImgSrc('');
      } catch (e) {
        console.error('Error al recortar la imagen:', e);
      }
    }
  };

  const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setSelectedFile(file);
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setImgSrc(reader.result as string);
        setShowCropModal(true);
      });
      reader.readAsDataURL(file);
    }
  };

  // Función para eliminar la foto de perfil
  const handleEliminarFoto = () => {
    // Limpiar la imagen recortada temporal
    setCroppedImage(null);
    
    // Limpiar la ruta de imagen de perfil en el formulario
    setFieldValue('ruta_imagen_perfil', '');
    
    // Limpiar cualquier archivo temporal
    setFieldValue('foto_perfil_temp', null);
    
    // console.log('Foto de perfil eliminada del formulario');
  };

  // Función para centrar el recorte cuando la imagen se carga
  const onImageLoad = () => {
    if (imgRef.current && containerRef.current) {
      const containerWidth = containerRef.current.clientWidth;
      const containerHeight = containerRef.current.clientHeight;
      const size = Math.min(containerWidth, containerHeight) * 0.8; // 80% del tamaño del contenedor
      
      setCrop({
        unit: 'px',
        width: size,
        height: size,
        x: (containerWidth - size) / 2,
        y: (containerHeight - size) / 2
      });
    }
  };

  // Verificar si hay una imagen de perfil (actual o temporal)
  const tieneImagen = croppedImage || ruta_imagen_perfil;

  return (
    <Grid item xs={12} sm={6}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
        <Typography variant="subtitle1" fontWeight="bold" align="center">Foto de Perfil</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2, mt: 1 }}>
          <Avatar
                            src={croppedImage || getFileUrl(ruta_imagen_perfil)}
            sx={{ 
              width: 80, 
              height: 80,
              '& img': {
                objectFit: 'cover',
                borderRadius: '50%'
              }
            }}
          >
            {!tieneImagen && nombre ? 
              nombre.split(' ').map(word => word.charAt(0)).join('').toUpperCase().slice(0, 2) : 
              ''
            }
          </Avatar>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Button variant="outlined" component="label" size="small">
              Cambiar Foto
              <input type="file" accept="image/*" hidden onChange={onFileChange} />
            </Button>
            {tieneImagen && (
              <Button 
                variant="outlined" 
                color="error" 
                size="small"
                onClick={handleEliminarFoto}
              >
                Eliminar Foto
              </Button>
            )}
          </Box>
        </Box>
      </Box>
      {/* Modal de recorte */}
      <Dialog
        open={showCropModal}
        onClose={() => setShowCropModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Recortar Imagen</DialogTitle>
        <DialogContent>
          {imgSrc && (
            <Box 
              ref={containerRef}
              sx={{ 
                mt: 2, 
                display: 'flex', 
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px'
              }}
            >
              <ReactCrop
                crop={crop}
                onChange={(c) => {
                  // Forzar que el recorte sea un círculo perfecto
                  const size = Math.min(c.width, c.height);
                  setCrop({
                    ...c,
                    width: size,
                    height: size
                  });
                }}
                aspect={1}
                circularCrop
                style={{
                  maxWidth: '100%',
                  maxHeight: '70vh'
                }}
              >
                <img
                  ref={imgRef}
                  src={imgSrc}
                  alt="Imagen a recortar"
                  onLoad={onImageLoad}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '70vh',
                    display: 'block',
                    objectFit: 'contain'
                  }}
                />
              </ReactCrop>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowCropModal(false)}>Cancelar</Button>
          <Button onClick={handleCropComplete} variant="contained" color="primary">
            Recortar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

function safeFormatDate(dateStr: any, isBirthDate: boolean = false) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return '';
  return format(date, isBirthDate ? 'dd/MM/yyyy' : 'dd/MM/yy');
}

// Función para generar UUID en el navegador
function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const limpiarRutaImagenPerfil = (ruta: string): string => {
  if (!ruta) return '';
  
  // En producción, mantener la ruta completa tal como viene
  if (process.env.NODE_ENV === 'production') {
    return ruta;
  }
  
  // En desarrollo, limpiar la ruta para guardar solo el nombre del archivo
  if (ruta.includes('/')) {
    return ruta.split('/').pop() || '';
  }
  
  return ruta;
};

const AgregarPaciente: FC = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [initialFormValues, setInitialFormValues] = useState<FormValues>(defaultValues);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [calendarDate, setCalendarDate] = useState<Date | null>(null);
  const [tabValue, setTabValue] = useState(0);
  const richTextEditorRef = useRef<any>(null);
  const formikRef = useRef<FormikProps<FormValues>>(null);
  const [obrasSociales, setObrasSociales] = useState<string[]>([]);
  const [analisis, setAnalisis] = useState<any[]>([]);
  const [analisisAEliminar, setAnalisisAEliminar] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState('');
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [pacienteSimilar, setPacienteSimilar] = useState<string | null>(null);
  const [pacienteDataToSave, setPacienteDataToSave] = useState<any>(null);
  const [tempFotoPerfil, setTempFotoPerfil] = useState<File | null>(null);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openExitDialog, setOpenExitDialog] = useState(false);
  const [esperandoConfirmacionNombreSimilar, setEsperandoConfirmacionNombreSimilar] = useState(false);
  const [accionPendiente, setAccionPendiente] = useState<'guardar' | 'guardarYSalir' | null>(null);
  const [tipoAccionSalida, setTipoAccionSalida] = useState<'guardarYSalir' | 'soloSalir'>('soloSalir');
  // Estado para Snackbar de advertencia
  const [warningSnackbar, setWarningSnackbar] = useState<{open: boolean, message: string}>({open: false, message: ''});

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const tabParam = searchParams.get('tab');
  const navigate = useNavigate();

  // Establecer el paso inicial basado en el parámetro tab de la URL
  useEffect(() => {
    if (tabParam !== null) {
      const tabIndex = parseInt(tabParam);
      if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < steps.length) {
        setActiveStep(tabIndex);
      }
    }
  }, [tabParam]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/pacientes`).then(res => {
      const obras = Array.from(new Set((res.data || []).map((p: any) => p.obra_social).filter(Boolean))) as string[];
      setObrasSociales(obras);
      setInitialFormValues(prev => ({ ...prev, obrasSociales: obras }));
    });
  }, []);

  // Agregar nuevo useEffect para actualizar obrasSociales cuando cambia el valor de obra_social
  useEffect(() => {
    if (formikRef.current) {
      const obraSocial = formikRef.current.values.obra_social;
      if (obraSocial && !obrasSociales.includes(obraSocial)) {
        setObrasSociales(prev => [...prev, obraSocial]);
      }
    }
  }, [formikRef.current?.values.obra_social]);

  useEffect(() => {
    const cargarDatos = async () => {
      if (id) {
        setLoading(true);
        try {
          await fetchPaciente();
          await fetchAnalisis();
        } catch (error) {
          console.error('Error al cargar datos:', error);
        } finally {
          setLoading(false);
        }
      }
    };
    
    cargarDatos();
  }, [id]);

  useEffect(() => {
    if (formikRef.current) {
      const values = {
        ...initialFormValues,
        analisis_clinicos: initialFormValues.analisis_clinicos || []
      };
      formikRef.current.setValues(values, false);
    }
  }, [initialFormValues]);

  // Agregar el listener para el evento de limpieza del formulario
  useEffect(() => {
    const handleLimpiarFormulario = () => {
      // Limpiar el formulario
      formikRef.current?.resetForm();
      // Resetear todos los estados
      setActiveStep(0);
      setCroppedImage(null);
      setAnalisis([]);
      setAnalisisAEliminar([]);
      setFechaNacimiento('');
      setTabValue(0);
      // Forzar la recarga de los valores iniciales
      setInitialFormValues({
        ...defaultValues,
        fecha_nacimiento: '',
        edad: 0,
        obra_social: '' // Asegurarnos de que el campo de obra social se limpie
      });
      // Asegurarnos de que los campos específicos se limpien
      if (formikRef.current) {
        formikRef.current.setFieldValue('edad', 0);
        formikRef.current.setFieldValue('fecha_nacimiento', '');
        formikRef.current.setFieldValue('obra_social', ''); // Limpiar explícitamente el campo de obra social
      }
    };

    window.addEventListener('limpiarFormularioPaciente', handleLimpiarFormulario);
    return () => {
      window.removeEventListener('limpiarFormularioPaciente', handleLimpiarFormulario);
    };
  }, []);

  useEffect(() => {
    if (formikRef.current) {
      setFechaNacimiento(formikRef.current.values.fecha_nacimiento);
    }
  }, [activeStep, formikRef.current?.values.fecha_nacimiento]);

  useEffect(() => {
    if (formikRef.current) {
      const values = formikRef.current.values;
      if (values.fecha_nacimiento && values.fecha_nacimiento.split('/')[2]?.length === 4) {
        const [dia, mes, anio] = values.fecha_nacimiento.split('/').map(Number);
        const fechaNac = new Date(anio, mes - 1, dia);
        const hoy = new Date();
        let edad = hoy.getFullYear() - fechaNac.getFullYear();
        const mesActual = hoy.getMonth();
        const mesNac = fechaNac.getMonth();
        if (mesActual < mesNac || (mesActual === mesNac && hoy.getDate() < fechaNac.getDate())) {
          edad--;
        }
        formikRef.current.setFieldValue('edad', edad);
      } else if (formikRef.current) {
        formikRef.current.setFieldValue('edad', '');
      }
    }
  }, [fechaNacimiento]);

  const fetchPaciente = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/pacientes/${id}`);
      const data = response.data;
      
      const formattedData: FormValues = {
        ...defaultValues,
        ...data,
        id: data.id || '',
        medico_id: data.medico_id || '',
        nombre: data.nombre || '',
        dni: data.dni || '',
        genero: data.genero || '',
        profesion: data.profesion || '',
        obra_social: data.obra_social || '',
        plan: data.plan || '',
        nro_socio: data.nro_socio || '',
        fecha_nacimiento: safeFormatDate(data.fecha_nacimiento, true),
        edad: data.edad || 0,
        altura_cm: data.altura_cm || 0,
        peso_kg: data.peso_kg || 0,
        religion: data.religion || '',
        familia: data.familia || '',
        email: data.email || '',
        email2: data.email2 || '',
        ruta_imagen_perfil: data.ruta_imagen_perfil || '',
        preferencias: data.preferencias || [],
        intolerancias: data.intolerancias || [],
        observaciones_alimentacion: data.observaciones_alimentacion || '',
        medicamentos: Array.isArray(data.medicamentos) ? data.medicamentos.map((med: any) => [
          med[0] || '', // fecha
          med[1] || '', // medicamento
          med[2] || '', // frecuencia
          med[3] || '', // duracion
          med[4] === 'true' || med[4] === true ? true : false // permanente (convertir string a boolean)
        ]) : [],
        vacunas: Array.isArray(data.vacunas) ? data.vacunas.map((vac: any) => [
          vac[1] || '', // fecha
          vac[0] || ''  // nombre
        ]) : [],
        pesos: Array.isArray(data.pesos) ? data.pesos.map((peso: any) => ({
          fecha: peso[0] || '',
          valor: peso[1] ? parseFloat((peso[1] + '').replace('kg', '').replace('KG', '').replace(' ', '').replace(',', '.')) : 0
        })) : [],
        peso_fecha: '',
        peso_valor: '',
        seguimiento: data.seguimiento?.map((seg: any) => ({
          fecha: safeFormatDate(seg?.fecha),
          texto: seg.texto || ''
        })) || [],
        analisis_resumen: data.analisis_resumen || '',
        analisis_clinicos: data.analisis_clinicos || [],
        analisis_fecha: '',
        analisis_archivo: null,
        analisis_nombre: '',
        obrasSociales: obrasSociales,
        
        // Aparato Circulatorio
        calambres: data.calambres || false,
        varices: data.varices || false,
        observaciones_circulatorio: data.observaciones_circulatorio || '',
        
        // Aparato Respiratorio
        alergias: data.alergias || false,
        fuma_fumo: data.fuma_fumo || false,
        observaciones_respiratorio: data.observaciones_respiratorio || '',
        
        // Aparato Digestivo
        gastritis: data.gastritis || false,
        frecuencia_intestino: data.frecuencia_intestino || '',
        gases_intestinales: data.gases_intestinales || false,
        dolor_abdominal: data.dolor_abdominal || false,
        hepatitis: data.hepatitis || false,
        observaciones_digestivo: data.observaciones_digestivo || '',
        
        // Aparato Urinario
        infecciones_urinarias: data.infecciones_urinarias || false,
        colicos_litiasis: data.colicos_litiasis || false,
        observaciones_urinario: data.observaciones_urinario || '',
        
        // Sistema Endocrino
        enfermedad_tiroides: data.enfermedad_tiroides || false,
        uso_corticoides: data.uso_corticoides || false,
        diabetes: data.diabetes || false,
        colesterol_elevado: data.colesterol_elevado || false,
        trigliceridos_elevado: data.trigliceridos_elevado || false,
        observaciones_endocrino: data.observaciones_endocrino || '',
        
        // Sistema Dermatológico
        manchas: data.manchas || false,
        piel_seca: data.piel_seca || false,
        piel_grasa: data.piel_grasa || false,
        urticaria_eczema: data.urticaria_eczema || false,
        caida_cabello: data.caida_cabello || false,
        fragilidad_unas: data.fragilidad_unas || false,
        observaciones_dermatologico: data.observaciones_dermatologico || '',
        
        // Sistema Locomotor
        zona_cervical: data.zona_cervical || false,
        zona_dorsal: data.zona_dorsal || false,
        zona_lumbar: data.zona_lumbar || false,
        mmii: data.mmii || false,
        mmss: data.mmss || false,
        observaciones_locomotor: data.observaciones_locomotor || '',
        
        // Enfermedades Infecciosas
        covid: data.covid || false,
        otras_infecciosas: data.otras_infecciosas || '',
        
        // Sistema Ginecológico - con migración de datos
        fum: (() => {
          // Migración: si fum es un string (formato antiguo), convertirlo a array
          if (typeof data.fum === 'string' && data.fum.trim()) {
            return [data.fum.trim()];
          }
          // Si ya es un array, usarlo tal como está
          if (Array.isArray(data.fum)) {
            return data.fum;
          }
          // Si no hay datos, array vacío
          return [];
        })(),
        nueva_fum_temp: '',
        embarazos: data.embarazos || '',
        fecha_ultimo_control: safeFormatDate(data.fecha_ultimo_control),
        climaterio: data.climaterio || false,
        observaciones_ginecologico: data.observaciones_ginecologico || '',
        
        // Antecedentes Quirúrgicos
        antecedentes_quirurgicos: data.antecedentes_quirurgicos || '',
        
        // Actividad Física y Sueño
        actividad_fisica: data.actividad_fisica || '',
        psicoanalisis: data.psicoanalisis || false,
        duerme_de: data.duerme_de || '',
        duerme_hasta: data.duerme_hasta || '',
        despertar_noche: data.despertar_noche || ''
      };
    
      setInitialFormValues(formattedData);
      if (data.ruta_imagen_perfil && data.medico_id && data.id) {
        if (process.env.NODE_ENV === 'production') {
          // En producción, usar la URL completa tal como viene
          setCroppedImage(data.ruta_imagen_perfil);
        } else {
          // En desarrollo, limpiar la ruta y construir la ruta local
          const nombreArchivo = limpiarRutaImagenPerfil(data.ruta_imagen_perfil);
          setCroppedImage(`${FILE_BASE_URL}/${data.medico_id}/${data.id} - ${data.nombre}/perfil/${nombreArchivo}`);
        }
      }
      
      // Auto-popular el peso basado en la fecha más reciente
      setTimeout(() => {
        autoPopulatePeso();
      }, 100);
    } catch (error) {
      console.error('Error al cargar el paciente:', error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const fetchAnalisis = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/pacientes/${id}/analisis`);
      setAnalisis(response.data);
      setInitialFormValues(prev => ({
        ...prev,
        analisis_clinicos: response.data
      }));
    } catch (error) {
      console.error('Error al cargar análisis:', error);
    }
  };

  const handleTabChange = (event: SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const onSelectFile = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      // console.log('Archivo seleccionado:', file.name, file.type, file.size);
      
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setCroppedImage(reader.result as string);
          });
      reader.readAsDataURL(file);

      // Guardar el archivo en el estado para subirlo después
      formikRef.current?.setFieldValue('foto_perfil_temp', file);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleGuardarYSalir = async () => {
    // console.log('🔍 DEBUG: handleGuardarYSalir ejecutándose');
    setAccionPendiente('guardarYSalir');
    setTipoAccionSalida('guardarYSalir');
    if (formikRef.current) {
      // console.log('🔍 DEBUG: FormikRef existe, validando formulario...');
      await formikRef.current.validateForm();
      const errors = formikRef.current.errors;
      // console.log('🔍 DEBUG: Errores de Formik:', errors);
      if (Object.keys(errors).length > 0) {
        // console.log('❌ ERROR: Hay errores de Formik, marcando campos como touched');
        formikRef.current.setTouched({ nombre: true, ...Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {}) });
        return;
      }
      const values = formikRef.current.values;
      // console.log('🔍 DEBUG: Valores del formulario:', values);
      // console.log('🔍 DEBUG: Medicamentos:', values.medicamentos);
      const errorPersonalizado = validacionPersonalizada(values);
      // console.log('🔍 DEBUG: Error personalizado:', errorPersonalizado);
      if (errorPersonalizado) {
        // console.log('❌ ERROR: Error personalizado encontrado, mostrando warning');
        showWarning(errorPersonalizado);
        return;
      }
      // console.log('✅ DEBUG: No hay errores, ejecutando guardar y salir directamente');
      // Ejecutar directamente sin mostrar popup
      try {
        await formikRef.current.submitForm();
        // console.log('✅ DEBUG: submitForm completado, navegando...');
        // Navegar al detalle del paciente después de guardar y salir
        if (values.id) {
          // console.log('🔍 DEBUG: Navegando a paciente:', values.id);
          navigate(`/pacientes/${values.id}`);
        } else {
          // console.log('🔍 DEBUG: Navegando a lista de pacientes');
          navigate('/pacientes');
        }
      } catch (error) {
        console.error('❌ ERROR: Error al guardar y salir:', error);
      }
    } else {
      // console.log('❌ ERROR: FormikRef no existe');
    }
  };

  const handleConfirmarGuardarYSalir = async () => {
    // console.log('🔍 DEBUG: handleConfirmarGuardarYSalir ejecutándose');
    try {
      if (formikRef.current) {
        // console.log('🔍 DEBUG: FormikRef existe en confirmación');
        await formikRef.current.validateForm();
        const errors = formikRef.current.errors;
        // console.log('🔍 DEBUG: Errores de Formik en confirmación:', errors);
        if (Object.keys(errors).length > 0) {
          // console.log('❌ ERROR: Hay errores de Formik en confirmación');
          formikRef.current.setTouched({ nombre: true, ...Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {}) });
          setOpenExitDialog(false);
          return;
        }
        const values = formikRef.current.values;
        // console.log('🔍 DEBUG: Valores en confirmación:', values);
        const errorPersonalizado = validacionPersonalizada(values);
        // console.log('🔍 DEBUG: Error personalizado en confirmación:', errorPersonalizado);
        if (errorPersonalizado) {
          // console.log('❌ ERROR: Error personalizado en confirmación');
          showWarning(errorPersonalizado);
          setOpenExitDialog(false);
          return;
        }
        // console.log('✅ DEBUG: Ejecutando submitForm en confirmación');
        await formikRef.current.submitForm();
        // console.log('✅ DEBUG: submitForm completado, navegando...');
        // Navegar al detalle del paciente después de guardar y salir
        if (values.id) {
          // console.log('🔍 DEBUG: Navegando a paciente:', values.id);
          navigate(`/pacientes/${values.id}`);
        } else {
          // console.log('🔍 DEBUG: Navegando a lista de pacientes');
          navigate('/pacientes');
        }
      } else {
        // console.log('❌ ERROR: FormikRef no existe en confirmación');
      }
    } catch (error) {
      console.error('❌ ERROR: Error al guardar y salir:', error);
    } finally {
      // console.log('🔍 DEBUG: Cerrando diálogo');
      setOpenExitDialog(false);
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const calcularEdad = (fechaNacimiento: string) => {
    if (!fechaNacimiento) return 0;
    const [dia, mes, anio] = fechaNacimiento.split('/').map(Number);
    const fechaNac = new Date(anio, mes - 1, dia);
    const hoy = new Date();
    let edad = hoy.getFullYear() - fechaNac.getFullYear();
    const mesActual = hoy.getMonth();
    const mesNac = fechaNac.getMonth();
    if (mesActual < mesNac || (mesActual === mesNac && hoy.getDate() < fechaNac.getDate())) {
      edad--;
    }
    return edad;
  };

  const hasMoreThan7Days = (dateStr: string) => {
    if (!dateStr) return false;
    const [dia, mes, anio] = dateStr.split('/').map(Number);
    const fecha = new Date(anio, mes - 1, dia);
    const hoy = new Date();
    const diffTime = Math.abs(hoy.setHours(0,0,0,0) - fecha.setHours(0,0,0,0));
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 7;
  };

  const autoPopulatePeso = () => {
    if (formikRef.current) {
      const values = formikRef.current.values;
      if (values.pesos && values.pesos.length > 0) {
        const pesosOrdenados = [...values.pesos].sort((a, b) => {
          const [diaA, mesA, anioA] = a.fecha.split('/').map(Number);
          const [diaB, mesB, anioB] = b.fecha.split('/').map(Number);
          const anioCompletoA = anioA < 50 ? 2000 + anioA : 1900 + anioA;
          const anioCompletoB = anioB < 50 ? 2000 + anioB : 1900 + anioB;
          const fechaA = new Date(anioCompletoA, mesA - 1, diaA);
          const fechaB = new Date(anioCompletoB, mesB - 1, diaB);
          return fechaB.getTime() - fechaA.getTime();
        });
        const pesoMasReciente = pesosOrdenados[0];
        
        // Verificar si el peso más reciente tiene menos de 8 días
        const [dia, mes, anio] = pesoMasReciente.fecha.split('/').map(Number);
        const anioCompleto = anio < 50 ? 2000 + anio : 1900 + anio;
        const fechaPeso = new Date(anioCompleto, mes - 1, dia);
        const hoy = new Date();
        const diffTime = Math.abs(hoy.setHours(0,0,0,0) - fechaPeso.setHours(0,0,0,0));
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        // Solo auto-popular si tiene menos de 8 días
        if (diffDays <= 7) {
          formikRef.current.setFieldValue('peso_kg', parseFloat(pesoMasReciente.valor.toFixed(3)));
        } else {
          // Si tiene más de 8 días, limpiar el campo de peso principal
          formikRef.current.setFieldValue('peso_kg', 0);
        }
      }
    }
  };

  // --- VALIDACIÓN PERSONALIZADA CENTRALIZADA ---
  const validacionPersonalizada = (values: FormValues): string | null => {
    // 1. Peso pendiente
    if ((values.peso_fecha && values.peso_fecha.trim() !== '') || (values.peso_valor && values.peso_valor.trim() !== '')) {
      if (!values.pesos.some(p => p.fecha === values.peso_fecha && String(p.valor) === values.peso_valor)) {
        return 'Tienes un peso o fecha pendiente de registrar. Por favor, presiona "Registrar" o limpia los campos.';
      }
    }
    // 2. Archivo de análisis sin fecha
    if (values.analisis_archivo && !values.analisis_fecha) {
      return 'Si seleccionas un archivo de análisis, la fecha es obligatoria.';
    }
    // 3. Archivo de análisis y fecha, pero no agregado
    if (values.analisis_archivo && values.analisis_fecha) {
      const yaAgregado = values.analisis_clinicos.some(a => a.fecha === values.analisis_fecha);
      if (!yaAgregado) {
        return 'Tienes un archivo de análisis y fecha listos pero no presionaste "Agregar análisis".';
      }
    }
    // 4. FUM pendiente de agregar
    if (values.nueva_fum_temp && values.nueva_fum_temp.trim() !== '') {
      return 'Tienes una fecha de FUM pendiente de agregar. Presiona "+" o limpia el campo.';
    }
    // 5. Medicamentos con datos incompletos
    const medicamentosIncompletos = values.medicamentos.some(med => {
      const [fecha, medicamento, frecuencia, duracion, permanente] = med;
      const duracionStr = duracion ? String(duracion) : '';
      const permanenteStr = permanente ? String(permanente) : '';
      const tieneAlgunDato = fecha?.trim() || medicamento?.trim() || frecuencia?.trim() || duracionStr.trim() || permanenteStr.trim();
      if (tieneAlgunDato) {
        const camposObligatoriosLlenos = fecha?.trim() && medicamento?.trim() && frecuencia?.trim();
        const duracionValida = permanenteStr.trim() || duracionStr.trim();
        const esIncompleto = !camposObligatoriosLlenos || !duracionValida;
        return esIncompleto;
      }
      return false;
    });
    if (medicamentosIncompletos) {
      return 'Tienes medicamentos con datos incompletos. Completa todos los campos obligatorios o elimina la fila.';
    }
    // 6. Vacunas con datos incompletos
    const vacunasIncompletas = values.vacunas.some(vac => {
      const [fecha, nombre] = vac;
      const tieneAlgunDato = fecha?.trim() || nombre?.trim();
      if (tieneAlgunDato) {
        const esIncompleta = !fecha?.trim() || !nombre?.trim();
        return esIncompleta;
      }
      return false;
    });
    if (vacunasIncompletas) {
      return 'Tienes vacunas con datos incompletos. Completa fecha y nombre o elimina la fila.';
    }
    return null;
  };

  const handleSubmit = async (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    // 1. Validaciones de UI (tu lógica aquí es correcta)
    const errorPersonalizado = validacionPersonalizada(values);
    if (errorPersonalizado) {
      showWarning(errorPersonalizado);
      setSubmitting(false);
      return;
    }
    setLoading(true);

    // 2. Construir el payload de datos. Simple, directo y completo.
    const pacienteData = {
      ...values, // ¡LA LÍNEA MÁS IMPORTANTE! Incluye todos los campos del formulario.
      nombre: values.nombre.trim(),
      // Formatear arrays para que coincidan con la estructura que espera el backend.
      pesos: values.pesos.map((peso: any) => [
        peso.fecha, 
        parseFloat(peso.valor).toFixed(3)
      ]),
      vacunas: values.vacunas.map((vac: any) => [vac[0], vac[1]]),
      medicamentos: values.medicamentos.map((med: any) => [
        med[0] || '',
        med[1] || '',
        med[2] || '',
        med[3] ? String(med[3]) : '',
        med[4] ? 'true' : 'false'
      ]),
    };

    if (id) {
      (pacienteData as any).ultima_modificacion = new Date().toISOString();
    }
    
    setPacienteDataToSave(pacienteData); // Guardar para posible reintento
    if (values.foto_perfil_temp) {
      setTempFotoPerfil(values.foto_perfil_temp);
    }

    try {
      // 3. Lógica de envío unificada
      const method = id ? 'put' : 'post';
      const url = id ? `${API_BASE_URL}/pacientes/${id}` : `${API_BASE_URL}/pacientes`;
      
      let response;
      
      if (values.foto_perfil_temp) {
        const formData = new FormData();
        formData.append('paciente', JSON.stringify(pacienteData));
        formData.append('file', values.foto_perfil_temp);
        response = await axios({ method, url, data: formData, headers: { 'Content-Type': 'multipart/form-data' } });
      } else {
        response = await axios({ method, url, data: pacienteData, headers: { 'Content-Type': 'application/json' } });
      }
      
      // 4. Manejo de respuesta exitosa
      const pacienteGuardado = response.data;
      if (formikRef.current && pacienteGuardado.id) {
        formikRef.current.setFieldValue('id', pacienteGuardado.id);
      }
      
      setOpenSuccessDialog(true);
      setTimeout(() => {
        setOpenSuccessDialog(false);
        
        // --- INICIO DE LA CORRECCIÓN DE NAVEGACIÓN ---
        const nuevoId = pacienteGuardado.id;

        if (accionPendiente === 'guardarYSalir' && nuevoId) {
          // Si la acción fue "Guardar y Salir", NAVEGAR DIRECTAMENTE A LA VISTA DE DETALLE.
          // NO a la lista de pacientes.
          navigate(`/pacientes/${nuevoId}`);
        } else if (!id && nuevoId) {
          // Si fue solo "Guardar" un nuevo paciente, recargar la página en modo edición.
          navigate(`/pacientes/agregar?id=${nuevoId}`, { replace: true });
        }
        // Si es una edición (id ya existía), no se necesita navegar a ningún lado,
        // ya que el usuario permanece en la misma página para seguir editando.
        // --- FIN DE LA CORRECCIÓN DE NAVEGACIÓN ---

      }, 2000);

    } catch (error: any) {
      // 5. Manejo del error 409 (nombre similar)
      if (!id && error.response?.status === 409) {
        setPacienteSimilar(error.response.data.detail);
        setOpenConfirmDialog(true);
      } else {
        console.error('Error al guardar paciente:', error);
        showWarning(`Error al guardar: ${error.response?.data?.detail || error.message}`);
      }
    } finally {
      setLoading(false);
      setSubmitting(false);
      setAccionPendiente(null);
    }
  };

  const handleConfirmSave = async () => {
    setOpenConfirmDialog(false);
    if (!pacienteDataToSave) {
      console.error("No hay datos de paciente para guardar en la confirmación.");
      return;
    }

    setLoading(true);

    const dataToSend = { ...pacienteDataToSave, confirmar_nombre_similar: true };

    try {
      let response;
      if (tempFotoPerfil) {
        const formData = new FormData();
        formData.append('paciente', JSON.stringify(dataToSend));
        formData.append('file', tempFotoPerfil);
        response = await axios.post(`${API_BASE_URL}/pacientes`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      } else {
        response = await axios.post(`${API_BASE_URL}/pacientes`, dataToSend, {
          headers: { 'Content-Type': 'application/json' },
        });
      }
      
      const pacienteCreado = response.data;
      setOpenSuccessDialog(true);
      setTimeout(() => {
        setOpenSuccessDialog(false);
        
        // --- INICIO DE LA CORRECCIÓN DE NAVEGACIÓN ---
        const nuevoId = pacienteCreado.id;

        if (accionPendiente === 'guardarYSalir' && nuevoId) {
          // NAVEGAR DIRECTAMENTE A LA VISTA DE DETALLE
          navigate(`/pacientes/${nuevoId}`);
        } else if (nuevoId) {
          // Si fue solo "Guardar", recargar la página en modo edición
          navigate(`/pacientes/agregar?id=${nuevoId}`, { replace: true });
        }
        // --- FIN DE LA CORRECCIÓN DE NAVEGACIÓN ---

      }, 2000);

    } catch (error: any) {
      console.error('Error al guardar paciente tras confirmación:', error);
      showWarning(`Error al confirmar: ${error.response?.data?.detail || error.message}`);
    } finally {
      setLoading(false);
      setPacienteSimilar(null);
      setPacienteDataToSave(null);
      setTempFotoPerfil(null);
      setAccionPendiente(null);
    }
  };

  const handleSalirSinGuardar = () => {
    setTipoAccionSalida('soloSalir');
    setOpenExitDialog(true);
  };

  const handleConfirmarSalida = () => {
    setOpenExitDialog(false);
    if (tipoAccionSalida === 'guardarYSalir') {
      handleConfirmarGuardarYSalir();
    } else {
      // Salir sin guardar: navegar al detalle si hay id, si no a la lista
      const id = formikRef.current?.values.id;
      if (id) {
        navigate(`/pacientes/${id}`);
      } else {
        navigate('/pacientes');
      }
    }
  };

  const handleCancelarSalida = () => {
    setOpenExitDialog(false);
  };

  const showWarning = (msg: string) => setWarningSnackbar({open: true, message: msg});
  const handleCloseWarning = () => setWarningSnackbar({open: false, message: ''});

  const handleGuardar = async () => {
    // console.log('🔍 DEBUG: handleGuardar ejecutándose');
    setAccionPendiente('guardar');
    if (formikRef.current) {
      // console.log('🔍 DEBUG: FormikRef existe, validando formulario...');
      await formikRef.current.validateForm();
      const errors = formikRef.current.errors;
      // console.log('🔍 DEBUG: Errores de Formik:', errors);
      if (Object.keys(errors).length > 0) {
        // console.log('❌ ERROR: Hay errores de Formik, marcando campos como touched');
        formikRef.current.setTouched({ nombre: true, ...Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {}) });
      }
      const values = formikRef.current.values;
      // console.log('🔍 DEBUG: Valores del formulario:', values);
      // console.log('🔍 DEBUG: Medicamentos:', values.medicamentos);
      const errorPersonalizado = validacionPersonalizada(values);
      // console.log('🔍 DEBUG: Error personalizado:', errorPersonalizado);
      if (errorPersonalizado) {
        // console.log('❌ ERROR: Error personalizado encontrado, mostrando warning');
        showWarning(errorPersonalizado);
        return;
      }
      // console.log('✅ DEBUG: No hay errores, ejecutando submitForm');
      await formikRef.current.submitForm();
    } else {
      // console.log('❌ ERROR: FormikRef no existe');
    }
  };

  const handleRemoveAnalisisFile = () => {
    if (formikRef.current) {
      formikRef.current.setFieldValue('analisis_archivo', null);
      formikRef.current.setFieldValue('analisis_fecha', '');
    }
  };

  if (loading) return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      gap: 2
    }}>
      <CircularProgress size={60} />
      <Typography variant="h6" color="text.secondary">
        Cargando datos del paciente...
      </Typography>
    </Box>
  );

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', p: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" gutterBottom>
            {id ? 'Editar Paciente' : 'Nuevo Paciente'}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            {/* Mostrar botón "Nuevo Paciente" solo cuando estamos editando un paciente */}
            {id && (
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={async () => {
                  // Primero navegar a la URL de nuevo paciente
                  navigate('/pacientes/agregar');
                  // Esperar un momento para asegurar que la navegación se complete
                  await new Promise(resolve => setTimeout(resolve, 100));
                  // Limpiar el formulario
                  formikRef.current?.resetForm();
                  // Resetear todos los estados
                  setActiveStep(0);
                  setCroppedImage(null);
                  setAnalisis([]);
                  setAnalisisAEliminar([]);
                  setFechaNacimiento('');
                  setTabValue(0);
                  // Forzar la recarga de los valores iniciales
                  setInitialFormValues({
                    ...defaultValues,
                    fecha_nacimiento: '',
                    edad: 0
                  });
                  // Asegurarnos de que el campo de edad se limpie
                  if (formikRef.current) {
                    formikRef.current.setFieldValue('edad', 0);
                    formikRef.current.setFieldValue('fecha_nacimiento', '');
                  }
                }}
                sx={{ mr: 1 }}
              >
                Nuevo Paciente
              </Button>
            )}
            <Button
              variant="outlined"
              color="error"
              onClick={handleSalirSinGuardar}
              sx={{ mr: 1 }}
            >
              Salir
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleGuardarYSalir}
              sx={{ mr: 1 }}
            >
              Guardar y Salir
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleGuardar}
            >
              Guardar
            </Button>
          </Box>
        </Box>

        <Formik
          initialValues={initialFormValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          innerRef={formikRef}
          enableReinitialize={true}
        >
          {({ values, setFieldValue, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }: FormikProps<FormValues>) => (
              <Form>
              <Box sx={{ maxWidth: { xs: '100vw', sm: 'none' }, overflowX: { xs: 'hidden', sm: 'visible' }, px: { xs: 0.5, sm: 2 } }}>
                <Box sx={{ width: '100%', overflowX: { xs: 'auto', sm: 'visible' }, mb: 2 }}>
                  <Stepper activeStep={activeStep} alternativeLabel orientation="horizontal">
                    {steps.map((label, index) => (
                      <Step key={label}>
                        <StepLabel
                          onClick={() => setActiveStep(index)}
                          sx={{
                            cursor: 'pointer !important',
                            '&:hover': {
                              color: 'primary.main'
                            }
                          } as any}
                        >
                          {label}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
                <Box sx={{ mt: 2, mb: 1 }}>
                  <StepContent
                    step={activeStep}
                    croppedImage={croppedImage}
                    onSelectFile={onSelectFile}
                    setFieldValue={setFieldValue}
                    values={values}
                    calcularEdad={calcularEdad}
                    hasMoreThan7Days={hasMoreThan7Days}
                    autoPopulatePeso={autoPopulatePeso}
                    obrasSociales={obrasSociales}
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    calendarDate={calendarDate}
                    setCalendarDate={setCalendarDate}
                    tabValue={tabValue}
                    handleTabChange={handleTabChange}
                    setCroppedImage={setCroppedImage}
                    id={id}
                    fetchAnalisis={fetchAnalisis}
                    analisisAEliminar={analisisAEliminar}
                    setAnalisisAEliminar={setAnalisisAEliminar}
                    handleRemoveAnalisisFile={handleRemoveAnalisisFile}
                  />
                </Box>
                <Popover
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={() => setAnchorEl(null)}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                    <DatePicker
                      value={calendarDate}
                      onChange={(date) => {
                        if (date) {
                          const formattedDate = date.toLocaleDateString('es-ES', {
                            day: '2-digit',
                            month: '2-digit',
                            year: '2-digit'
                          });
                          if (anchorEl?.getAttribute('data-field')) {
                            setFieldValue(anchorEl.getAttribute('data-field')!, formattedDate);
                          }
                        }
                        setAnchorEl(null);
                      }}
                      slotProps={{
                        textField: {
                          variant: 'outlined',
                          fullWidth: true,
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Popover>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                  >
                    Atrás
                  </Button>
                  <Box>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={handleGuardarYSalir}
                      sx={{ mr: 1 }}
                    >
                      Guardar y Salir
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleNext}
                    >
                      {activeStep === steps.length - 1 ? 'Finalizar' : 'Siguiente'}
                    </Button>
                  </Box>
                  </Box>
                </Box>
              </Form>
          )}
        </Formik>
      </Paper>
      
      {/* Agregar el Dialog de confirmación */}
      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
      >
        <DialogTitle>Confirmar creación de paciente</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {pacienteSimilar ? pacienteSimilar + ' ' : ''}
            ¿Estás seguro que deseas crear un nuevo paciente?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmDialog(false)}>Cancelar</Button>
          <Button onClick={handleConfirmSave} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de éxito al guardar */}
      <Dialog
        open={openSuccessDialog}
        onClose={() => setOpenSuccessDialog(false)}
        disableEscapeKeyDown
      >
        <DialogTitle sx={{ textAlign: 'center', color: 'success.main' }}>
          ✅ ¡Guardado Exitosamente!
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ textAlign: 'center', fontSize: '1.1rem' }}>
            Los datos del paciente se han guardado correctamente.
            <br />
            <small style={{ color: 'text.secondary' }}>
              Este mensaje se cerrará automáticamente en unos segundos...
            </small>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openExitDialog}
        onClose={handleCancelarSalida}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {tipoAccionSalida === 'guardarYSalir' ? '¿Guardar y salir?' : '¿Salir sin guardar?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {tipoAccionSalida === 'guardarYSalir' 
              ? '¿Estás seguro que deseas guardar los cambios y salir? Los datos se guardarán antes de salir.'
              : '¿Estás seguro que deseas salir sin guardar los cambios? Se perderán todos los datos ingresados.'
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelarSalida}>Cancelar</Button>
          <Button 
            onClick={handleConfirmarSalida} 
            color={tipoAccionSalida === 'guardarYSalir' ? 'primary' : 'error'} 
            autoFocus
          >
            {tipoAccionSalida === 'guardarYSalir' ? 'Guardar y Salir' : 'Salir sin guardar'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar de advertencia visual */}
      <Snackbar
        open={warningSnackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseWarning}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert onClose={handleCloseWarning} severity="warning" sx={{ width: '100%' }}>
          {warningSnackbar.message}
        </MuiAlert>
      </Snackbar>
    </Box>
  );
};

export default AgregarPaciente; 